export default {
  email: 'E-posta',
  password: 'Şifre', // User interface label for password input
  passwordEntry: 'Şifreniz', // User interface label for password entry
  confirmPassword: 'Şifreyi Doğrula', // User interface label for confirming password
  usernameRequired: 'Kullanıcı adınızı girin.', // User interface message for username required
  passwordRequired: 'Şifrenizi girin.', // User interface message for password required
  user: 'Kullanıcı',
  view: 'Görüntüle',
  edit: 'Düzenle',
  add: 'Ekle',
  duplicate: 'Kopyala',
  reload: 'Yenile',
  download: 'İndir',
  downloadAll: 'Tümünü İndir',
  downloadFile: 'Belgeyi İndir',
  filters: 'Filtreler',
  thereIsNoFileExist: 'Belge Mevcut Değil',
  fileExist: 'Belge Mevcut',
  delete: 'Pasif Yap',
  remove: 'Sil',
  save: 'Kaydet',
  saveAndNext: 'Kaydet ve İlerle',
  detail: 'Detay',
  showDetail: 'Detayı Görüntüle',
  logOut: 'Çıkış Yap',
  tour: 'Yardım',
  operations: 'İşlemler',
  totalRecord: 'Toplam Kayıt',
  slots: 'Slotlar',
  city: 'Şehir',
  selectCity: 'Şehir seçiniz.',
  country: 'Ülke',
  selectCountry: 'Ülke seçiniz.',
  cityCode: 'Şehir Kodu',
  geocodingApiType: 'Coğrafi Kodlama',
  selectGeocoding: 'Coğrafi kodlama uygulaması seçiniz.',
  matrixType: 'Matrix Tipi',
  selectMatrixType: 'Matrix tipi seçiniz.',
  isActive: 'Aktif mi?',
  warehouseCode: 'Depo Kodu',
  warehouseName: 'Depo Adı',
  lat: 'Enlem',
  lon: 'Boylam',
  parameterProfileAdd: 'Parametre Profil Ekle',
  parameterProfileEdit: 'Parametre Profil Düzenle',
  parameterProfileName: 'Profil Adı',
  parameterProfileStatus: 'Durumu',
  parameterName: 'Adı',
  parameterMappingCode: 'Eşleme Kodu',
  parameterType: 'Tipi',
  selectParameterType: 'Parametre tipi seçiniz.',
  value: 'Değer',
  isMainParameter: 'Ana Parametre Mi?',
  zone: 'Zone',
  profile: 'Profil',
  selectZone: 'Zone seçiniz.',
  flatDeliveryFee: 'Baremli Teslimat Ücreti',
  selectProfile: 'Profil seçiniz.',
  mainParameterName: 'Ana Parametre Adı',
  selectMainParameter: 'Ana parametre seçiniz.',
  showParameter: 'Parametre Gösterilsin Mi?',
  parameterProfileCreatedTime: 'Oluşturulma Zamanı',
  parameterProfileCreatedBy: 'Oluşturan Kullanıcı',
  isActiveProfile: 'Durumu',
  modalDeleteTitle: 'Emin Misiniz?',
  modalDeleteContent: 'Seçtiğiniz kaydı silmek istediğinize emin misiniz?',
  citiesServedDelete: 'Seçilen şehir pasife alınacak.',
  yes: 'Evet',
  cancel: 'İptal',
  processCompleted: 'İşlem Tamamlandı',
  saveSuccessNotify: 'Değişiklik Kaydedildi',
  duplicateCompleted: 'Seçtiğiniz kayıt kopyalandı.',
  processInCompleted:
    'Hata, Sadece Sipariş Atanmış Dağıtıcılar Arasında Değişiklik Yapılabilir.',
  deletedRecord: 'Seçtiğiniz kayıt başarıyla silindi.',
  deleted: 'Kayıt Başarıyla Silindi',
  deletedCitiesServed: 'Seçilen şehir pasife alındı.',
  addedCitiesServed: 'Hizmet verilen şehir eklendi.',
  editedCitiesServed: 'Hizmet verilen şehir düzenlendi.',
  parameterCategory: 'Kategorisi',
  defaultValue: 'Varsayılan Değer',
  parameterGroup: 'Parametre Grubu',
  parameterExistence: 'Parametre Varlığı',
  addParametersDetail: 'Yeni Parametre Grubu Oluşturma',
  parametersDetailDeleteConfirm: 'parametre grubu silinecek.',
  parametersDetailDeleted: 'Parametre grubu silindi.',
  addedParametersDetail: 'Parametre grubu eklendi.',
  editParametersDetail: 'Parametre Grubu Düzenleme',
  ParametersDetailUpdated: 'Parametre grubu güncellendi.',
  selectParameterCategory: 'Parametre kategorisi seçiniz.',
  addedRoutingParameter: 'Rotalama parametresi eklendi.',
  editedRoutingParameter: 'Rotalama parametresi düzenlendi.',
  deletedRoutingParameter: 'Rotalama parametresi silindi.',
  parameterValueCompleted: 'Rotalama parametre değerleri kaydedildi.',
  selectedRoutingParameter: 'Seçilen rotalama parametresi silinecek.',
  addedNewPolygon: 'Polygon eklendi.',
  updatedNewPolygon: 'Polygon güncellendi.',
  polygonWillDelete: 'adlı polygon silinecek.',
  polygonDeleted: 'Polygon silindi.',
  selectPolygon: 'Polygon seçiniz.',
  polygonSummary: 'Sipariş Özeti',
  addPolygon: 'Yeni Polygon Oluşturma',
  polygonName: 'Polygon Adı',
  showAllStores: 'Tüm Mağazaları Göster',
  hideAllStores: 'Tüm Mağazaları Gizle',
  storeEcomStatus: 'Mağaza Ecom Statüsü',
  m2Info: 'M² Bilgisi',
  minCannotBeGreaterThanMax: 'Min, max değerinden büyük olamaz!',
  maxCannotBeLessThanMin: 'Max, min değerinden küçük olamaz!',
  editPolygon: 'Polygon Düzenleme',
  showZones: 'Zoneleri Göster',
  zones: 'Mağazanın Zonelerı',
  zoneName: 'Zone Adı',
  storeWhereDelivered: 'Siparişin Teslim Edildiği Mağaza',
  courierIdentityNumber: 'Dağıtıcı TCKN',
  courierPhoneNumber: 'Dağıtıcı Tel',
  directorate: 'Direktörlük',
  maxWeeksAllowed: 'Belirtilen hafta sayısını aşmayınız',
  DELETED: 'Silindi',
  errorMessageNoCourier:
    'Herhangi bir dağıtıcı seçilmemiş! Lütfen en az bir tane dağıtıcı seçiniz!',
  errorMessageNoOrder: 'Herhangi bir sipariş seçilmemiş.',
  errorTwoTittle: 'Kurye sayısı sipariş adedinden büyük olamaz.',
  errorTwoContent:
    'Rotalama, dağıtıcı sayısı sipariş sayısından büyük olduğu için başlatılamadı!',
  infoTittle: 'Rotalama işlemi devam ediyor...',
  infoContent: 'Rotalama işlemi devam ederken yeni bir rotalama başlatılamaz.',
  errorTaskIdTitle: 'Rotalama yapılmadı!',
  errorTaskIdContent:
    'Devam edebilmek için önce rotalama işlemini tamamlamalısınız.',
  errorMonitoringTaskTitle: 'Analiz başlatılmadı!',
  errorMonitoringTaskContent:
    'Devam edebilmek için task statüsü "TAMAMLANDI" aşamasında olmalıdır.',
  errorParentTypeContent:
    'Ana depo olarak seçilen zone bilgisinde en az iki saat seçilmelidir veya dar zone üzerinden rotalama yapılmalıdır.',
  errorStartTimeBeforeEndTime: 'Başlangıç saati bitiş saatinden küçük olmalıdır',
  showOnForm: 'Ekranda Gösterilsin Mi?',
  monitoring: 'Rota İzleme',
  snsSendTitle: 'Başarılı',
  snsSendDesc: 'Rotalama SNS e başarıyla gönderildi.',
  snsSendTitleError: 'Başarısız',
  snsSendDescError: 'Rotalama SNS e gönderilemedi.',
  courierName: 'Dağıtıcı Adı',
  courierSource: 'Dağıtıcı Firma Bilgisi',
  courierSources: 'Dağıtıcı Firma',
  refresh: 'Yenile',
  courierCode: 'Sicil Numarası',
  visitOrderNo: 'Sıra',
  orderId: 'Sipariş No',
  customerName: 'Müşteri Adı',
  address: 'Adres',
  username: 'Kullanıcı Adı',
  usernameEntry: 'Kullanıcı Adınız',
  loginError: 'Kullanıcı adı veya parola hatalı',
  licensePlate: 'Plaka',
  citiesServedAdd: 'Hizmet Verilen Şehir Ekleme',
  citiesServedEdit: 'Hizmet Verilen Şehir Düzenleme',
  parameterAdd: 'Parametre Ekleme',
  parameterEdit: 'Parametre Düzenleme',
  slotId: 'Slot ID',
  slotLastOrderTime: 'Son Sipariş Zamanı',
  slotBeginTime: 'Başlangıç Saati',
  slotEndTime: 'Bitiş Saati',
  monday: 'Pazartesi',
  tuesday: 'Salı',
  wednesday: 'Çarşamba',
  thursday: 'Perşembe',
  friday: 'Cuma',
  saturday: 'Cumartesi',
  sunday: 'Pazar',
  deliveryFee: 'Teslimat Ücreti',
  zoneId: 'Zone Kodu',
  minimumCartAmount: 'Minimum Sepet Tutarı',
  maximumCartAmount: 'Maksimum Sepet Tutarı',
  addedCourier: 'Dağıtıcı eklendi.',
  addedTaskGroup: 'Mağaza çizelgesi eklendi.',
  addTaskPlan: 'Yeni Çizelge Şablonu Oluşturma',
  actions: 'Aksiyonlar',
  actionName: 'Aksiyon Adı',
  isRequired: 'Zorunlu Olsun',
  actionError: 'En fazla 2 aksiyon seçilebilir.',
  editTaskPlan: 'Çizelge Şablonu Düzenleme',
  schedule: 'Çizelge',
  ecommerceTask: 'E-Ticaret Mağazası Görevi',
  taskPriority: 'Öncelik',
  addTaskGroup: 'Yeni Görev Grubu Oluşturma',
  taskOpening: 'Açılış',
  taskClosing: 'Kapanış',
  freeTimeSelection: 'Serbest Saat Seçimi',
  editTaskGroup: 'Görev Grubu Düzenleme',
  addedTaskPlan: 'Çizelge şablonu eklendi.',
  taskPlanUpdated: 'Çizelge şablonu güncellendi.',
  addedTaskGroup: 'Görev grubu eklendi.',
  taskGroupUpdated: 'Görev grubu güncellendi.',
  addedTaskTemplate: 'Görev eklendi.',
  taskTemplateUpdated: 'Görev güncellendi.',
  scheduleTemplateName: 'Çizelge Şablon Adı',
  taskGroupName: 'Görev Grubu Adı',
  addTaskTemplates: 'Yeni Görev Oluşturma',
  taskPlanDeleted: 'Çizelge şablonu silindi.',
  taskGroupDeleted: 'Görev grubu silindi.',
  taskTemplateDeleted: 'Görev silindi.',
  taskTemplateName: 'Görev Adı',
  taskPeriod: 'Periyot',
  taskOrder: 'Görev Sırası',
  taskDesc: 'Görev Tanımı',
  source: 'Kaynak',
  openingAndClosingTime: 'Açılış ve Kapanış Saati',
  openingTime: 'Açılış Saati',
  closingTime: 'Kapanış Saati',
  taskWithDayAndMont: 'Görevin Çalışacağı Ay ve Gün Bilgisi',
  weekDaysCombination: 'Ayın Hafta Sırası ve Günleri',
  daysOfMonth: 'Ayın Günleri',
  dayChoose: 'Gün Seçimi',
  frequency: 'Frekans',
  errorMessageSamePriority: 'Aynı öncelikte görev oluşturulamaz!',
  editTaskTemplate: 'Görev Düzenleme',
  endDateMustBeAfterStartDate: 'Bitiş tarihi başlangıç tarihinden sonra olmalıdır.',
  relationTime: 'Görev Zamanı',
  taskDuration: 'Süre (Saat)',
  taskPlanDeleteConfirm: 'çizelge şablonunu silinecek.',
  taskGroupDeleteConfirm: 'görev grubu silinecek.',
  taskTemplateDeleteConfirm: 'görevi silinecek.',
  deliveryCode: 'Sipariş Kodu',
  orderCourierManagementDeleteConfirm: 'Seçili siparişin dağıtıcı kaydı silinecek.',
  orderCourierManagementDeleted: 'Seçili siparişin dağıtıcı kaydı silindi.',
  addOrderCourierManagement: 'Sipariş Dağıtıcı Oluşturma',
  addedOrderCourierManagement: 'Sipariş dağıtıcı eklendi.',
  editOrderCourierManagement: 'Sipariş Dağıtıcı Düzenleme',
  orderCourierManagementUpdated: 'Sipariş dağıtıcı güncellendi.',
  courierAdd: 'Dağıtıcı Ekleme',
  courierInfo: 'Dağıtıcı Bilgileri',
  courierDocument: 'Belgeler',
  hesKod: 'Hes Kodu',
  distributionEdu: 'Dağıtım Eğitimi',
  drivingEdu: 'Sürüş Eğitimi',
  covid19Vaccine: 'Covid 19 Aşı Durumu',
  fullName: 'Ad Soyad',
  phoneNumber: 'Telefon Numarası',
  identityNumber: 'TC Kimlik Numarası',
  tcknVkn: 'TCKN/VKN',
  tcknVknErrMessage: 'TCKN/VKN 11/10 karakter olmalıdır',
  tcknErrMessage: 'TCKN 11 karakter olmalıdır',
  idNumberToBeInvoiced: 'Fatura Kesilecek TC Kimlik Numarası',
  birthDate: 'Doğum Tarihi',
  gender: 'Cinsiyet',
  male: 'Erkek',
  female: 'Kadın',
  courierApplicationsDetail: 'Esnaf Kurye Başvuruları Detayı',
  hasYes: 'Var',
  hasNo: 'Yok',
  p1AuthorizationCertificate: 'P1 Yetki Belgesi',
  soleProprietorship: 'Şahıs Şirketi',
  regionsToBeServed: 'Hizmet Verilmek İstenilen İlçeler',
  salaryExpectation: 'Maaş Beklentisi',
  contractApprovalPermission: 'Sözleşme Onay İzni',
  applicationDate: 'Başvuru Tarihi',
  color: 'Renk',
  editedCourier: 'Dağıtıcı bilgileri düzenlendi.',
  courierEdit: 'Dağıtıcı Düzenleme',
  id: 'Id',
  courierStatus: 'Dağıtıcı Durumu',
  CouriersAwaitingDetail: 'Onay Bekleyen Dağıtıcılar Detayı',
  CouriersAwaitingDetailUpdated: 'Onay Bekleyen Dağıtıcının Durumu Güncellendi',
  MOTORCYCLE: 'Motosiklet',
  COMMERCIAL_VEHICLE: 'Ticari Araç',
  PASSENGER_VEHICLE: 'Binek Araç',
  createdTime: 'Kayıt Tarihi',
  courierDelete: 'Seçilen dağıtıcı pasife alınacak.',
  courierActive: 'Seçilen dağıtıcı aktife alınacak.',
  deletedCourier: 'Dağıtıcı pasife alındı.',
  addedVehicleGroup: 'Araç grubu eklendi.',
  vehicleGroupActive: 'Seçilen araç grubu aktifleştirilecek.',
  vehicleGroupStatusChanged: 'Araç grubunun aktiflik durumu değiştirildi.',
  vehicleGroupEdited: 'Araç grubu düzenlendi.',
  vehicleGroup: 'Araç Grubu',
  vehicleGroupAdd: 'Araç Grubu Ekleme',
  capacityInfo: 'Kapasite Bilgileri',
  capacityKg: 'Kapasite (KG)',
  capacityQuantity: 'Kapasite (Adet)',
  capacityCc: 'Kapasite (CC)',
  costInfo: 'Maliyet Bilgileri',
  fixedCost: 'Sabit Maliyeti',
  changingCost: 'Değişken Maliyeti',
  transportationCost: 'Taşıma Maliyeti',
  waitingCost: 'Bekleme Maliyeti',
  workInfo: 'Çalışma Bilgileri',
  workBeginTime: 'Ç. Başlangıç Saati',
  workBeginTimePlaceHolder: 'Çalışma Başlangıç Saati Seçiniz..',
  workEndTime: 'Ç. Bitiş Saati',
  workEndTimePlaceHolder: 'Çalışma Bitiş Saati Seçiniz..',
  breakBeginTime: 'M. Başlangıç Saati',
  breakBeginTimePlaceHolder: 'Mola Başlangıç Saati Seçiniz..',
  breakEndTime: 'M. Bitiş Saati',
  breakEndTimePlaceHolder: 'Mola Bitiş Saati Seçiniz..',
  breakDuration: 'Mola Süresi',
  freeDay: 'İzin Günü',
  maximumDailyDistance: 'Maximum G. Mesafe',
  averageLoadDuration: 'Ortalama Y. Süresi',
  editedVehicleGroup: 'Araç grup bilgileri düzenlendi.',
  vehicleGroupEdit: 'Araç Grubu Düzenleme',
  vehicleGroupDelete: 'Seçilen araç grubu pasife alınacak.',
  deletedVehicleGroup: 'Araç grubu pasife alındı.',
  vehicleAdd: 'Araç Ekleme',
  vehicleInfo: 'Araç Bilgileri',
  vehicleBrand: 'Marka',
  vehicleModel: 'Model',
  year: 'Yıl',
  warehouse: 'Dağıtım Merkezi',
  isInterfered: 'Müdahale Edildi Mi?',
  routeId: 'Rotalama ID',
  lastCourier: 'Son Sürücü',
  vehicleStatus: 'Durumu',
  nodeId: 'Node id',
  vehicleEdit: 'Araç Düzenleme',
  vehicleType: 'Araç Tipi',
  vehicleDelete: 'Seçilen araç pasife alınacak.',
  vehicleActive: 'Seçilen araç aktifleştirilecek.',
  vehicleStatusChanged: 'Aracın aktiflik durumu değiştirildi.',
  deletedVehicle: 'Araç pasife alındı.',
  logoUniqueCode: 'Ürün Kodu',
  productName: 'Ürün Adı',
  quantity: 'Adet',
  no: 'Hayır',
  newShipment: 'Yeni Gönderi',
  courierStartEndTime: 'Kurye Çalışmaya Başlama-Bitirme Tipi',
  packaging: 'Toplanmaya Başladı',
  waitingForCourier: 'Toplama Tamamlandı',
  inTransit: 'Dağıtımda',
  delivered: 'Teslim Edildi',
  replaced: 'Slot Değişimi',
  orderDetail: 'Sipariş Detayı',
  generalInfo: 'Genel Bilgiler',
  orderCreatedTime: 'Oluşturma Tarihi',
  date: 'Tarih',
  oldCapacity: 'Eski Kapasite',
  action: 'İşlem',
  newCapacity: 'Yeni Kapasite',
  deliveryDate: 'Dağıtım Tarihi',
  plateNumber: 'Plaka',
  elite: 'Elit',
  frozen: 'Donuk',
  amountInfo: 'Tutar Bilgileri',
  amountInformation: 'Ödeme Bilgileri',
  price: 'Fiyat',
  totalDiscount: 'Toplam İndirim',
  totalRefunded: 'Toplam Geri Ödenen',
  totalRefundedAmount: 'Toplam İade Tutarı',
  totalPaid: 'Ödenen',
  otherInfo: 'Diğer Bilgiler',
  shipmentStatus: 'Gönderi Durumu',
  slotTime: 'Slot',
  platform: 'Platform',
  orderItems: 'Siparişteki Ürünler',
  orderItemInformation: 'Ürün Bilgileri',
  addressInfo: 'Adres Bilgileri',
  updateAddress: 'Adresi Güncelle',
  addressPlaceholder: 'Adres Giriniz..',
  orderDelete: 'Seçilen sipariş pasife alınacak.',
  deletedOrder: 'Sipariş pasife alındı.',
  neighborhood: 'Mahalle',
  route: 'Rotala',
  analyze: 'Analiz Et',
  applyRoute: 'Rotalamayı Onayla',
  approve: 'Onayla',
  reject: 'Reddet',
  sendToFinanceApproval: 'Muhasebe Onayına Gönder',
  all: 'Tümü',
  selectAll: 'Tümünü Seç',
  lateDuration: 'Gecikme',
  searchCourierPlaceholder: 'Dağıtıcı arama...',
  distance: 'Mesafe',
  km: 'km',
  time: 'Süre',
  min: 'dk',
  vehicle: 'Araç',
  totalVehicle: 'Toplam Araç',
  listCourierCount: 'Toplam Dağıtıcı: ',
  selectCourierCount: 'Seçilen Dağıtıcı: ',
  planned: 'Planlanan',
  unplanned: 'Planlanmayan',
  total: 'Toplam',
  ordersTotal: 'Toplam Sipariş',
  totalExpediton: 'Sefer',
  listOrderCount: 'Toplam Sipariş: ',
  selectOrderCount: 'Seçilen Sipariş: ',
  taskId: 'Task ID',
  solverStatus: 'Task Statüsü',
  taskStartTime: 'Task Başlangıç Saati',
  taskEndTime: 'Task Bitiş Saati',
  completed: 'Tamamlandı',
  continues: 'Devam Ediyor',
  failed: 'Başarısız',
  uncompleted: 'Tamamlanmadı',
  routingErrorContent:
    'Rotalama yapılırken hata oluştu. Lütfen tekrar rotalamayı deneyiniz.',
  completedValue: 'COMPLETED',
  unsolvedValue: 'UNSOLVED',
  taskfailedValue: 'Task failed',
  estimatedArrivalTime: 'Tahmini Teslim Tarihi',
  orangeColorCode: '#f58634',
  redColorCode: '#F32B00',
  greenColorCode: '#52c41a',
  actualArrivalTime: 'Gerçekleşen Teslim Tarihi',
  cancelled: 'İptal Edildi',
  companyName: 'Firma',
  inActive: 'Pasif',
  roles: 'Roller',
  distributionCenters: 'Tanımlı Depolar',
  editedUser: 'Kullanıcı düzenlendi.',
  userDelete: 'Seçilen kullanıcı pasife alındı.',
  colorAdd: 'Renk Ekle',
  addedColor: 'Renk eklendi.',
  chooseColor: 'Renk Seçiniz: ',
  assignSlots: 'Slot-Grup eşleştirmesi',
  required: 'Zorunlu alan!',
  error: 'Hata!',
  errorMainZones: 'Sadece ana zonelara bu işlemi yapabilirsiniz.',
  errorSubZones: 'Sadece alt zonelara bu işlemi yapabilirsiniz.',
  takeFewMinutes: 'Bu işlem birkaç dakika sürebilir.',	
  allZoneUpdateWarning:'Bu ekranda yapacağınız değişiklikler tüm zonelar üzerinde uygulanacaktır, devam etmek istiyor musunuz?',
  allSlotUpdateWarning:'Bu ekranda yapacağınız değişiklikler geri alınamayacktır, devam etmek istiyor musunuz?',
  slotTemplatesSuccessfullyUpdated: 'Yaptığınız değişiklikler tüm slotlar üzerinde uygulanmaya başlandı.',
  minimumCartAmountSuccessfullyUpdated: 'Minimum sepet tutarı için değişiklikler tüm zonelar üzerinde uygulanmaya başlandı.',
  deliveryFeesSuccessfullyUpdated: 'Baremli teslimat ücreti için değişiklikler tüm zonelar üzerinde uygulanmaya başlandı.',
  deliveryFeeDtoList: 'Teslimat Ücreti',
  addedZone: 'Zone Eklendi.',
  editedZone: 'Zone Düzenlendi',
  userAdd: 'Kullanıcı Ekle',
  userEdit: 'Kullanıcı Düzenle',
  authorizedStores: 'Yetkili Olduğu Mağazalar :',
  ok: 'Tamam',
  show: 'Göster',
  showClusteredMarkers: 'Kümeleşmiş İşaretçileri Göster',
  type: 'Tipi',
  shipmentType: 'Sipariş Tipi',
  return: 'İade',
  orderReplaced: 'Değişim',
  slot: 'Slot',
  greenSheen: '#68B0AB',
  orange: '#F07B3F',
  grey: '#838383',
  blue: '#3865a3',
  green: '#64a338',
  purple: '#B8B5FF',
  actualDeliveryDate: 'Dağıtıcı Teslim Zamanı',
  actualDeliveryTime: 'Dağıtıcı Teslim Zamanı',
  vehicleArrivalTime: 'Araç Varış Zamanı',
  transitStartTime: 'Dağıtıma Başlama Zamanı',
  sendToSnsTime: 'Rotalama Bitiş Zamanı',
  exportAll: 'Tüm Raporu İndir',
  deliveredOrderCount: 'Teslim Edilen Sipariş Adedi',
  cancelledOrderCount: 'İptal Edilen Sipariş Adedi',
  lateDeliveredOrderCount: 'Geciken Sipariş Adedi',
  latePickedOrderCount: 'Depo Gecikmeli Sipariş Adedi',
  totalRouteLength: 'Toplam Yapılan KM',
  info: 'Bilgi',
  liveFeedNoDataError: 'Aradığınız siparişin canlı takip verisi bulunamadı.',
  realExitTimeFromDistributionCenter: 'Gerçekleşen Depodan Çıkış Zamanı',
  estimatedFirstOrderDeliveryTime: 'Tahmini İlk Sipariş Teslim Zamanı',
  realFirstOrderDeliveryTime: 'Gerçekleşen İlk Sipariş Teslim Zamanı',
  estimatedReturnTime: 'Tahmini Dönüş Zamanı',
  realReturnTime: 'Gerçekleşen Dönüş Zamanı',
  reRoute: 'Yeniden Rotala',
  reRoutingModalMessage:
    'Yeniden rotalama işlemi başlatıldı. Rotalama sonucunuz otomatik onaylanacaktır. Rotalama işlemi tamamlanana kadar bu sayfayı kapatmayınız.',
  reRoutingInformationMessage:
    'Bu işlemden sonra kurye değişikliğinin yansıması için yeniden rotalama yapılması gerekmektedir.İşlemi tamamladıktan sonra yeniden rotala butonunu kullanarak bu işlemi gerçekleştirebilirsiniz.',
  warning: 'Uyarı',
  paymentType: 'Ödeme Tipi',
  name: 'İsim',
  firmName: 'Firma İsmi',
  store: 'Mağaza',
  activeStore: 'Aktif Mağaza',
  firms: 'Firmalar',
  firmAdd: 'Firma Ekle',
  firmEdit: 'Firma Düzenle',
  firmDeleted: 'Firma silindi.',
  firmDelete: 'Firmayı Sil',
  chooseFirm: 'Firma Seçiniz',
  addedFirm: 'Firma eklendi.',
  editedFirm: 'Firma düzenlendi.',
  userInfo: 'Kullanıcı Bilgileri',
  addRole: 'Rol Ekle',
  addNewRole: 'Yeni Rol Ekle',
  addImage: 'Görsel Ekle',
  deleteRole: 'Rolü Sil',
  firm: 'Firma',
  firmCurrent: 'Firma Cari',
  courierType: 'Dağıtıcı Tipi',
  createdAt: 'Dağıtıcı Oluşturma Talep Tarihi',
  createdByCourier: 'Dağıtıcıyı Oluşturan Kullanıcı',
  definedAnyRole: 'Hiç bir rol tanımlamadınız!',
  activeStoreNotInDefinedStores:
    'Aktif mağaza, kullanıcının tanımlı mağazaları arasında değil!',
  vehicles: 'Araçlar',
  chooseVehicleGroup: 'Araç Grubu Seçiniz',
  chooseVehicleModel: 'Araç Modeli Seçiniz',
  vehicleDeleted: 'Araç silindi!',
  addedVehicle: 'Araç eklendi!',
  editedVehicle: 'Araç düzenlendi!',
  courierType_STAFF: 'Kadrolu',
  courierType_TRADESMAN: 'Esnaf',
  isActive_true: 'Aktif',
  isActive_false: 'Pasif',
  userDeleted: 'Kullanıcı pasife alındı!',
  addUser: 'Kullanıcı Ekle',
  editUser: 'Kullanıcı Düzenle',
  regions: 'Bölgeler',
  region: 'Bölge',
  administrativeRegion: 'İdari Bölge',
  regionDelete: 'Bölgeyi Sil',
  regionDeleted: 'Bölge Silindi!',
  addedRegion: 'Bölge Eklendi!',
  editedRegion: 'Bölge Düzenlendi!',
  activeRegion: 'Aktif Bölge',
  regionAdd: 'Bölge Ekle',
  regionEdit: 'Bölge Düzenle',
  addedUser: 'Kullanıcı Eklendi!',
  currencyAccount: 'Firma Cari',
  sendLink: 'Link Gönder',
  stores: 'Mağazalar',
  chooseStore: 'Mağaza Seç',
  sentLink: 'Link gönderildi.',
  userNotCollectorOrCourier: 'Bu kullanıcı, dağıtıcı veya toplayıcı değildir!',
  role: 'Rol',
  courier: 'Dağıtıcı',
  collector: 'Toplayıcı',
  changeCourier: 'Dağıtıcı Değiştir',
  courierChanged: 'Dağıtıcı değiştirildi.',
  usersSentLinks: 'Link Gönderilen Kullanıcılar ',
  orderNo: 'Sipariş No',
  statusOfTheOrderIsNotSuitableForChangingTheCourier:
    'Bu siparişin kuryesi değiştirilemez, siparişin durumunu kontrol ediniz!',
  watchLive: 'Canlı İzle',
  requiredStore: 'Mağaza zorunludur!',
  regionName: 'Bölge Adı',
  regionCode: 'Bölge Kodu',
  active: 'Aktif',
  passive: 'Pasif',
  activate: 'Aktifleştir',
  userActivate: 'Seçilen kullanıcı aktifleştirilecek.',
  selectStore: 'Mağaza seçiniz',
  applicability: 'Geçerlilik',
  allStoresApplicability: 'Tüm Mağazalarda Geçerli Olsun',
  specificStoresApplicability: 'Belirli Mağazalarda Geçerli Olsun',
  regionalManager: 'Bölge Yöneticisi',
  regionalManagerPhoneNum: 'Bölge Yöneticisi Telefon Numarası',
  regionId: 'Bölge ID',
  storeId: 'Mağaza ID',
  selectRegion: 'Bölge Seçiniz',
  selectActiveStoreOrRegion: 'Aktif mağaza/bölge seçiniz',
  selectRole: 'Rol seçiniz',
  selectStoreOrRegion: 'Mağaza/Bölge seçiniz',
  enterPassword: 'Lütfen şifrenizi giriniz',
  ORDER_ZONE: 'Sipariş Zone',
  STORE_ZONE: 'Mağaza Zone',
  RED_ZONE: 'Red Zone',
  ACTIVE: 'Aktif',
  PASSIVE: 'Pasif',
  true: 'Evet',
  false: 'Hayır',
  versionApprovalStatus: 'Zone Onay Durumu',
  enterLocation: 'Bir konum giriniz (29.101,32.335)',
  locationWarningMessage: 'Lütfen doğru formatta giriniz: 40.234,29.337',
  modalConfirm: 'Emin misiniz?',
  sendConfirmZone: 'Onaya göndermek istediğinize emin misiniz?',
  heatmap: 'Isı Haritası',
  totalOrders: 'Toplam Sipariş Adedi',
  onTimeOrders: 'Zamanında Teslim edilen Sipariş Adedi',
  cancelledOrders: 'İptal Sipariş Adedi',
  notOnTimeOrders: 'Geciken Sipariş Adedi',
  returnedOrders: 'Tam Teslim Edilen Sipariş Adedi',
  notReturnedOrders: 'Parçalı Teslim Edilen Sipariş Adedi',
  storeDetails: 'Mağaza Detayları',
  heatmapSettings: 'Harita Ayarları',
  includeDeliveryFromStore: 'Mağazadan Gel Al Siparişleri',
  dateRangeForHeatmap: 'Isı Haritası Tarih Aralığı',
  dateRangeForOrder: 'Sipariş Tarih Aralığı',
  zoneCode: 'Zone Kodu',
  zoneName: 'Zone Adı',
  areaKm: 'Alan(km²)',
  storeCode: 'Mağaza Kodu',
  slotDayCount: 'Slot Gün Sayısı',
  slotDayCountRange: 'Slot gün sayısı 1 ile 9 arasında olmalıdır.',
  isOvenAvailable: 'Fırın Bilgisi',
  areaM2: 'M2 Bilgisi',
  mainZoneMinimumCartAmount: 'Ana Zone Min. Sepet Tutarı',
  storeZoneDeliveryFees: 'Teslimat Ücret Baremleri',
  deliveryFeeInfo: 'Teslimat Ücret Bilgileri',
  storeName: 'Mağaza Adı',
  storeStatus: 'Mağaza Durumu',
  storeNumber: 'Mağaza Tel No',
  storePhoneNumber: 'Mağaza Telefonu',
  storeNumber2: 'Mağaza Tel No 2',
  storeEdit: 'Mağaza Düzenle',
  storeType: 'Mağaza Tipi',
  normNumber: 'Norm Sayısı',
  cityName: 'İl',
  districtName: 'İlçe',
  maxCharacterExceed: 'Max karakter sayısını(80 karakter) aştınız!',
  passwordLength: 'Şifreniz minimum 8 karakter uzunluğunda olmalıdır!', // Validation message, not a hardcoded credential
  pricePerOrder: 'Paket Başına Ücret',
  orderCountLimitExceed:
    'İndirmek istediğiniz sipariş sayısı çok fazla olduğu için indirilemiyor.',
  courierShiftReport: 'Dağıtıcı Mesai Raporu',
  courierDistanceReport: 'Dağıtıcı Mesafe Raporu',
  code: 'Kod',
  status: 'Durum',
  polygonHaveMinThreePoints:
    'Yanlış polygon çizimi yaptınız, polygon un en az 3 noktası olmalı!',
  polygonTooLarge: "Belirtilen alandan daha büyük bir alan seçemezsiniz",
  polygonArea: 'Polygon Alanı',
  invalidPolygon: 'Yanlış polygon!',
  import: 'İçe Aktar',
  bulkAddAndUpdate: 'Toplu Ekleme/Güncelleme',
  makeActiveOrPassive: 'Toplu Aktif/Pasif Yap',
  downloadExampleTemplate: 'Örnek Şablon İndir',
  uploadReadyTemplate: 'Hazır Şablonunu Yükle',
  infoForBulkAddEdit:
    'Toplu yükleme yapmak için örnekte bulunan formatta formatta bir Excel yüklemeniz gerekmektedir.',
  infoForBulkAddEditCourier1:
    'Eğer toplu yeni dağıtıcı eklemek isterseniz bütün alanların dolu olması gerekmektedir.Boş bir alan olduğu takdirde dağıtıcı eklenmeyecektir.',
  infoForBulkAddEdit1:
    'Eğer toplu güncelleme yapmak isterseniz yıldızlı alanları ve güncellemek istediğiniz alanları doldurmanız yeterlidir.',
  infoForBulkAddEditUser1:
    'Eğer toplu yeni toplayıcı eklemek isterseniz bütün alanların dolu olması gerekmektedir.Boş bir alan olduğu takdirde toplayıcı eklenmeyecektir.',
  infoForBulkActivePassiveUpdate:
    'Toplu aktife/pasife çekmek için örnekteki formatta bir Excel yüklemeniz gerekmektedir.',
  zoneSlotImport: 'Zone Slot İçe Aktar',
  infoForZoneSlotImport:
    "Doğru formatta data yüklemek için örnek şablondaki 'Açıklama' sayfasını inceleyiniz.Toplu yükleme işlemi ile sadece yeni kayıt oluşturulmaz aynı zamanda ilgili zone'a ait kesişen tarihlerde farklı bir eşleşme kaydı var ise onları da günceller.",
  infoForZoneSlotImport1:
    'İlgili dosyayı yükledikten sonra kayıtlarınız anında sisteme işlenmeyebilir. İşlemin durumu veya dosyadaki dataların hata verip vermediği ile alakalı farklı bir ekrandan takibi yapılabilir.Hatalı satırların hata detayı ilgili sayfadan görüntülenirken başarılı satırlar işleme alınır. ',
  bulkActivePassiveUpdate: 'Toplu Aktif/Pasife Çekme',
  onlyAcceptExcel: 'Sadece .xls ve .xlsx uzantılı dosyalar yüklenmelidir.',
  fileUploadSuccess: 'Dosya başarıyla yüklendi.',
  selectFile: 'Lütfen bir dosya seçiniz!',
  fileUploadError:
    'Dosya yükleme sırasında bir hata oluştu. Formatı kontrol ediniz.',
  select: 'Seçiniz',
  maxCapacity: 'Max kapasite 999999!',
  MONDAY: 'Pazartesi',
  TUESDAY: 'Salı',
  WEDNESDAY: 'Çarşamba',
  THURSDAY: 'Perşembe',
  FRIDAY: 'Cuma',
  SATURDAY: 'Cumartesi',
  SUNDAY: 'Pazar',
  change: 'Değiştir',
  copy: 'Kopyala',
  common: {
    all: 'Tümü',
    eliteUser: 'Elit Kullanıcı',
    order: 'Sipariş',
    orderStop: 'Durak',
    degree: 'Derece',
  },
  mainDashboard: {
    kpiPrimaryColor: '#4B7BE5',
    kpiWarningColor: '#FFCE55',
    kpiDangerColor: '#F26E53',
    kpiSuccessColor: '#5BC1A6',
    completedColor: '#5BC1A6',
    inTransitColor: '#FFCE55',
    cancelledColor: '#F26E53',
    kpiOnTimeDeliveryText: 'Zamanında Teslim Oranı',
    kpiDeliveredOrderCountForToday: 'Bugün {{count}} sipariş teslim edildi',
    kpiOnTimeDeliveryLowColor: '#F26E53',
    kpiOnTimeDeliveryNormalColor: '#FFCE55',
    kpiOnTimeDeliveryHighColor: '#5BC1A6',
    kpiRouteComplianceRateToday: 'Rota Uyum Oranı',
    kpiRouteComplianceRateLowColor: '#F26E53',
    kpiRouteComplianceRateNormalColor: '#FFCE55',
    kpiRouteComplianceRateHighColor: '#5BC1A6',
    kpiIndividualInDistributionVehicleCountForToday:
      'Bugün Dağıtıma Çıkan Araç Sayısı',
    kpiRouteLengthText: 'Bugün Hesaplanan Routi Mesafe',
    kpiRealLengthPositiveText:
      'Gerçekleşen {{realLength}} km, Routi %{{effectiveness}} daha verimli',
    kpiRealLengthNegativeText:
      'Gerçekleşen {{realLength}} km, Routi %{{effectiveness}} daha az verimli',
    kpiChangedCourierCountForToday: 'Bugün Kurye Değişiklik Sayısı',
    kpiExcludedOrderCountForToday: 'Bugün Rotalanmayan Sipariş Sayısı',
    kpiExcludedOrderCountForYesterday: 'Dün {{count}} sipariş rotalanmadı',
    kpiActiveOrderCountForToday: 'Bugün Sipariş Sayısı',
    kpiActiveOrderCountForYesterday: 'Dün {{count}} sipariş oluşturuldu',
    kpiCurrentSlotOrderCountText: 'Aktif Slot Sipariş Sayısı',
    kpiNextSlotOrderCountText: 'Gelecek slot {{count}} sipariş bulunmakta',
    kpiReturnOrderCountForToday: 'Bugün İade Sipariş Sayısı',
    kpiReturnOrderCountForYesterday: 'Dün {{count}} sipariş iade edildi',
    kpiReplacedOrderCountForToday: 'Bugün Slotu Değişen Sipariş Sayısı',
    kpiReplacedOrderCountForYesterday: 'Dün {{count}} siparişin slotu değişti',
    dashboardDeliverySummaryForToday: 'Bugünün Slot Sipariş Teslim Özeti',
    vehicleTemperatureAlert: 'Araç Sıcaklık Alarmı',
    onTimeDeliveryRateToday: 'Zamanında Teslim Oranı',
  },
  fleetManagement: {
    vehicleType: 'Araç Tipi',
    changeVehicleType: 'Araç Tipini Değiştir',
    vehicle: {
      assetCode: 'Varlık Kodu',
      vehicleOwner: 'Araç Sahibi',
      vehicleParticipationDate: 'Araç Katılım Tarihi',
      operationParticipationDate: 'Operasyon Katılım Tarihi',
      modelYear: 'Model Yılı',
      vehicleUsageType: 'Araç Kullanım Tipi',
    },
  },
  bonusManagement: {
    component: 'Bileşen',
    bonusComponents: 'Prim Bileşenleri',
    bonusRules: 'Prim Kuralları',
    bonusOperations: 'Prim İşlemleri',
    componentName: 'Bileşen Adı',
    effect: 'Etki',
    weight: 'Ağırlık',
    active: 'Aktif',
    isActive: 'Aktif mi?',
    passive: 'Pasif',
    createdTime: 'Oluşturulma Tarihi',
    addedBonusParameter: 'Prim Parametreleri Eklendi!',
    addedBonusComponent: 'Prim Bileşeni Eklendi!',
    bonusComponent: 'Prim Bileşeni',
    value: 'Değer',
    select: 'Seçim',
    addNewRule: 'Yeni Kural Ekle',
    rules: 'Kurallar',
    logicalConnective: 'Mantıksal Bağlantı',
    bracket: 'Parantez',
    vehicleType: 'Araç Tipi',
    vehicleUsageType: 'Araç Kullanım Tipi',
    distributionCenter: 'Dağıtım Merkezi',
    numberOfDeliveredOrdersGte: 'Teslim Edilen Sipariş Sayısı >=',
    numberOfDeliveredOrdersLte: 'Teslim Edilen Sipariş Sayısı <=',
    actualTraveledDistanceGte: 'Gerçek Gidilen Mesafe >=',
    actualTraveledDistanceLte: 'Gerçek Gidilen Mesafe <=',
    paidLeaveHour: 'Ücretli İzin Saati',
    unpaidLeaveHour: 'Ücretsiz İzin Saati',
    weeklyLeaveHour: 'Haftalık İzin Saati',
    numberOfPublicHolidayShift: 'Resmi Tatil Vardiya Sayısı',
    workHour: 'Toplam Çalışma Saati',
    totalLeaveHour: 'Toplam İzin Saati',
    rule: 'Kural',
    ruleList: 'Kural Listesi',
    parameterList: 'Parametre Listesi',
    componentList: 'Bileşen Listesi',
    selectComponent: 'Bileşen Seçiniz',
    noBrackets: 'Parantez Yok',
    bonusComponentDelete: 'Seçilen bileşen pasife alınacak.',
    deletedBonusComponent: 'Bileşen pasife alındı.',
    deleteBonusComponent: 'Bileşeni Pasife Al',
    addedBonusOperations: 'Prim işlemleri eklendi.',
    editedBonusComponent: 'Prim bileşeni güncellendi.',
    deleteOperation: 'İşlemi Sil',
    bonusOperationDelete: 'Seçilen işlem pasife alınacak.',
    deletedOperation: 'Seçilen işlem pasife alındı.',
    deleteOperationAndRecreate: 'İşlemi Sil ve Yeniden Oluştur',
    predefinedRules: 'Önceden Tanımlanmış Kurallar',
    deleteRuleAndRecreate: 'Kuralı Sil ve Yeniden Oluştur',
    bonusRuleDelete: 'Seçilen kural pasife alınacak.',
    deleteRule: 'Kuralı Sil',
    deletedRule: 'Kural pasife alındı.',
    warehouse: 'Dağıtım Merkezi',
    no: 'No',
    bonusId: 'Bonus ID',
    period: 'Dönem',
    vehicleCount: 'Araç Sayısı',
    totalPayCut: 'Toplam Kesinti',
    totalPaymentAmount: 'Ödeme Tutarı',
    totalNetAmount: 'Toplam Net Ödeme',
    status: 'Durum',
    plateNumber: 'Plaka',
    vehiclePlateInfo: 'Araç Plaka Bilgisi',
    distance: 'Mesafe(KM)',
    totalOrderCount: 'T.E.Sipariş Sayısı(Net Adet)',
    publicHolidayCount: 'Resmi Tatil Sayısı',
    payCutCount: 'Kesinti Kayıt Sayısı',
    componentOne: 'Bileşen 1',
    componentTwo: 'Bileşen 2',
    componentThree: 'Bileşen 3',
    componentFour: 'Bileşen 4',
    componentFive: 'Bileşen 5',
    componentSix: 'Bileşen 6',
    componentSeven: 'Bileşen 7',
    totalPay: 'Net Ödeme',
    calculateBonus: 'Prim Hesapla',
    orderCount: 'Sipariş Sayısı',
    approved: 'Onaylandı',
    notApproved: 'Onaylanmadı',
    bonusApproveTitle: 'Prim Onaylama',
    approveBonus: 'Onayla',
    cancel: 'İptal',
    ok: 'Tamam',
    bonusApproveMessage:
      'Seçilen prim hesabı onaylanacaktır. Devam etmek istiyor musunuz ?',
    editPreparedData: 'Veri Düzenleme',
    selectBonusPeriod: 'Prim dönemi seçiniz',
    dontDeletedApprovedData: 'Onaylanmış veriler silinemez',
    bonusSummary: 'Prim Özeti',
    courier: 'Dağıtıcı',
    notificationDate: 'Kesinti Bildirim Tarihi',
    cutReason: 'Kesinti Nedeni',
    price: 'Kesinti Bedeli',
    courierPayCutDelete: 'Seçilen dağıtıcı kesintisi pasife alınacak.',
    deleteCourierPayCut: 'Dağıtıcı Kesintisini Sil',
    deletedCourierPayCut: 'Seçilen dağıtıcı kesintisi pasife alındı.',
    addedCourierPayCut: 'Kesinti eklendi.',
    courierPayCut: 'Dağıtıcı Kesinti Bildirimi',
    customerComplaint: 'Müşteri Şikayeti',
    other: 'Diğer',
    description: 'Açıklama',
    prepareData: 'Verileri Hazırla',
    editedCourierPayCut: 'Dağıtıcı Kesintisi düzenlendi.',
    addedWorkingHours: 'Çalışma saatleri eklendi.',
    workingHours: 'Çalışma Saatleri',
    zone: 'Zone',
    dailyWorkingHour: 'Günlük Çalışma Saati',
    operationOrderIncorrect: 'İşlem sırası hatalıdır, lütfen kontrol ediniz!',
    parameter: 'Parametre',
    bonusComponentParameters: 'Prim Bileşen Parametreleri',
    addNewParameter: 'Yeni Parametre Ekle',
    deleteParameter: 'Parametreyi Sil',
    selectParameter: 'Parametre Seçiniz',
    ruleName: 'Kural Adı',
    ruleDefinitions: 'Kural Tanımları',
    reportName: 'PrimDetayRaporu.xlsx',
    VAN: 'Van',
    MOTORCYCLE: 'Motor',
    DEDICATED: 'Dedike',
    SPOT: 'Spot',
    addValue: 'Değer Ekle',
    selectDate: 'Tarih Seçiniz',
    selectRule: 'Kural Seçiniz',
    ruleDefinitionList: 'Kural Tanım Listesi',
    parameters: 'Parametreler',
    ruleDefinition: 'Kural Tanımı',
    subRuleDefinitions: 'Alt Kural',
    addRuleDefinition: 'Yeni Kural Tanımı Ekle',
    addNewOperationExistingWillBeDeleted:
      'Yeni işlem eklerseniz mevcut işleminiz silinecektir.',
    selectEffect: 'Etki Seçiniz',
    selectActivity: 'Aktiflik Seçiniz',
    selectDistCenter: 'Dağıtım Merkezi Seçiniz',
    selectCourier: 'Dağıtıcı Seçiniz',
    selectPlate: 'Plaka Seçiniz',
    selectCutReason: 'Kesinti Nedeni Seçiniz',
    definedAnyOperation:
      'Tanımlanmış bir işleminiz yoktur, lütfen önce işlem tanımlayınız!',
  },
  zoneManagement: {
    definedAnyPolygon: 'Tanımlanmış bir alan yoktur, lütfen bir alan çiziniz!',
    zoneType: 'Zone Tipi',
    storeName: 'Mağaza Adı',
    zoneDelete: 'Zone u Sil',
    orderZone: 'Sipariş Zone',
    storeZone: 'Mağaza Zone',
    status: 'Durum',
    selectZoneType: 'Zone Tipi Seçiniz',
    zoneColor: 'Zone Rengi',
    showCustomers: 'Müşterileri Göster',
    transparency: 'Saydamlık',
    zoneAdd: 'Zone Ekle',
    zoneName: 'Zone Adı',
    zoneStatus: 'Zone Durumu',
    selectZoneStatus: 'Zone Durumu Seçiniz',
    note: 'Not',
    saveAndSendForApproval: 'Kaydet ve Onaya Gönder',
    zoneApprovalStatus: 'Zone Onay Durumu',
    selectZoneApprovalStatus: 'Zone Onay Durumu Seçiniz',
    approvalStatus: 'Onay Durumu',
    selectParentOfZone: 'Ana Zone Seçiniz',
    parentOfZone: 'Bağlı Olduğu Zone',
    zoneCode: 'Zone Kodu',
    saveAndApprove: 'Kaydet ve Onayla',
    updater: 'Güncelleyen',
    updatedDate: 'Güncellenme Tarihi',
    inUse: 'Kullanımda',
    isInUse: 'Kullanımda mı?',
    notInUse: 'Kullanımda Değil',
    recommendIsochroneZone: 'İzokron Bölge Öner',
    popupText: 'Süre Girin (Önerilen: 6.0): ',
    isCreateDefaultSlots: 'Varsayılan Şablona Göre Slot Oluştur',
    selectedDeliveryModel: 'Sevkiyat Yöntemleri Seçiniz',
  },
  slotManagement: {
    changeCourierReturnIndicator: 'Dağıtım Merkezine Dönüşü Ayarla',
    changeCourierReturnIndicatorModalHeader:
      'Dağıtım Merkezine Dönüş Zorunluluğunu Değiştir',
    changeCourierReturnIndicatorInfo:
      '{{slot}} Slotu için gün bazında kuryenin dağıtım merkezine dönme zorunluluğunu aşağıdan değiştirebilirsiniz.',
    templateName: 'Şablon Adı',
    templateCode: 'Şablon Kodu',
    isMainTemplate: 'Ana Şablon mu?',
    mainTemplate: 'Ana Şablon',
    description: 'Açıklama',
    status: 'Durum',
    changeStatus: 'Durum Değiştir',
    slotTemplates: 'Slot Şablonları',
    templateStatusChanged: 'Seçilen şablonların durumu değiştirildi.',
    templateEdited: 'Seçilen şablonlar düzenlendi.',
    deleteTemplate: ' şablonu/şablonları silinecek.',
    changeStatusTemplate:
      ' şablonu/şablonlarının aktiflik durumları değiştirilecektir.',
    delete: 'Sil',
    templateDeleted: 'Şablon silindi.',
    defaultTemplateForAllMessage:
      'Mevcutta ana şablon seçilidir. Yine de değiştirmek istiyor musunuz',
    slotsCapacity: 'Kapasite',
    addTemplateSuccess: 'Şablon eklendi.',
    createAutoSlot: 'Otomatik Slot Oluştur',
    createSlot: 'Slot Oluştur',
    startAndFinishDate: 'Başlangıç ve Bitiş Saati',
    slotRange: 'Slot Aralığı (dk)',
    startTime: 'Başlangıç Saati',
    finishTime: 'Bitiş Saati',
    cannotBeSplit:
      'Slot aralığı, başlangıç ve bitiş saatleri arasında tam bölünmelidir!',
    youHaveSlots:
      'Slot oluşturulacak günde önceden eklenmiş slotunuz vardır, yine de oluştumak istiyor musunuz ?',
    youHaveAlreadySlotsForCopy:
      'Kopyalama yaptığınız günlerde mevcut slotlar güncellenecektir. Onaylıyor musunuz ?',
    editTemplateSuccess: 'Şablon düzenlendi.',
    editTemplate: 'Şablon Düzenle',
    addTemplate: 'Şablon Ekle',
    applyAllDays: 'Tüm günlere uygula',
    hasConflictMessage:
      'Seçilen tarhiler arasında çakışma bulunmaktadır. Onaylamanız durumunda yeni şablon geçerli olacaktır.',
    applyTemplate: 'Şablon Uygula',
    changeStatusSuccess: 'Slot Şablon durumu değiştirildi.',
    deleteSuccessMessage: 'Seçilen Slot Şablonlar Silindi.',
    cutOffTime: 'Cut Off Saati',
    deleteConfirmMessage:
      'Seçilen şablon eşleştirmeleri silinecektir, onaylıyor musunuz ?',
    changeStatusConfirmMessage:
      'Şablon-Zone eşleştirmelerinin aktiflik durumu değiştirilecektir, onaylıyor musunuz ?',
    masterTemplateCannotBeDeleted: 'Ana şablon Eşleştirmeleri silinemez.',
    newSlot: 'Yeni Slot',
    autoSlot: 'Otomatik Slot',
    copySlot: 'Slot Kopyala'
  },
  routingDetail: {
    orderRequestedSize: 'Toplam Sipariş',
    planned: 'Planlanan',
    orderExcludedSize: 'Planlanmayan',
    expeditionCount: 'Sefer Sayısı',
    courierIncludedSize: 'Araç',
    totalDistanceInMeter: 'Planlanan Mesafe',
    estimatedRouteLength: 'Planlanan Mesafe',
    calculatedRouteLength: 'Gerçekleşen Mesafe',
    totalDurationInSecond: ' Planlanan Toplam Rota Süresi',
    orderDeliverySuccessRate: 'Teslimat Tamamlama',
    distributionStart: 'Dağıtım Başlangıç',
    distributionEnd: 'Dağıtım Bitiş',
    estimatedArrivalTime: 'Planlanan Teslimat Saati',
    actualArrivalTime: 'Gerçekleşen Teslimat Saati',
    calculationError: 'GPS verisi düzgün gelmediği için hesaplama yapılamıyor!',
    lastCalculationTime: 'Son Hesaplama Zamanı',
    doubleDistributor: 'Sevkiyatları iki dağıtıcı arasında değiştir',
    doubleDistributorDesc:
      'Sevkiyatları iki dağıtıcı arasında değiştirilmesini sağlar',
    shareDistributor:
      'Sevkiyatın tamamını diğer dağıtıcıya ata veya dağıtıcılar arasında paylaştır',
    shareDistributorDesc:
      'Sevkityatın tamamının başka bir dağıtıcıya atamanıza veya diğer dağıtıcılara paylaştırılmasını sağlar',
    courierAndOrderRequired:
      'Lütfen Dağıtıcı ve Sipariş Alanlarını Boş Bırakmayınız',
    changeDistributor: 'Dağıtıcı Değiştir',
    selectChangeDistributorOptions:
      'Yapmak İstediğiniz Dağıtıcı Değiştirme İşlemini Seçiniz',
    sourceCourier: 'Kaynak Dağıtıcı',
    reqSourceCourier: 'Kaynak Dağıtıcı Boş Bırakılamaz',
    reasonForChange: 'Değişiklik Sebebi',
    reqReasonForChange: 'Değişiklik Sebebi Boş Bırakılamaz',
    selectDestinationCourier: 'Hedef Dağıtıcı Seçiniz',
    reqSelectDestinationCourier: 'Hedef Dağıtıcı Boş Bırakılamaz',
    selectOrders: 'Siparişleri Seçiniz',
    reqSelectOrders: 'Sipariş Boş Bırakılamaz',
    againRouting: 'Yeniden Rotala',
    againRoutingDesc:
      'Dağıtıcı değiştir işleminden sonra kurye değişikliğinin yansıması için yeniden rotalama yapılması gerekmektedir. Yeni bir dağıtıcı değişikliği veya yeniden rotalama yapabilirsiniz?',
    changeRedistributor: 'Yeni Bir Dağıtıcı Değiştir',
    VEHICLE_BREAKDOWN: 'ARAÇ ARIZASI',
    COURIER_DISCOMFORT: 'KURYE RAHATSIZLIĞI',
    VEHICLE_ACCIDENT: 'ARAÇ KAZASI',
    WRONG_COURIER: 'YANLIŞ KURYE',
    COMPANY_INCORRECT_INFORMATION: 'YANLIŞ FİRMA BİLGİSİ',
    INSUFFICIENT_DOCUMENTATION: 'YETERSİZ DÖKÜMANTASYON',
    LACK_OF_COURIER: 'KURYE YETERSİZLİĞİ',
    OUT_OF_OPERATION: 'OPERASYON DIŞI',
    changeCourierMinReq: 'Teslim edilmemiş sipariş bulunamamaktadır.',
    reRouteSuccess: 'Rotalama işlemi başarıyla gerçekleştirildi.',
    reRoutingMessage: 'Rotalama işlemi gerçekleştiriliyor lütfen bekleyiniz...',
    distributionStartAndEndTime: 'Dağıtım Başlangıç/Bitiş Zamanı',
    plannedStartAndEndTime: 'Planlanan Başlangıç/Bitiş Zamanı',
  },
  courierChange: 'Dağıtıcı Değiştir', //tablo sütunu olduğu için
  routeCourierManagement: {
    changeCourier: 'Dağıtıcı Değiştir',
    changeReason: 'Değişiklik Sebebi',
    sourceCourier: 'Kaynak Dağıtıcı',
    targetCourier: 'Hedef Dağıtıcı',
    courierChangeBackgroundColor: '#2e9ffc',
    addNewTargetCourier: 'Yeni Hedef Dağıtıcı Ekle',
    changeWorkOrdersBetweenCouriers:
      'İş emirlerini dağıtıcılar arasında değiştir.',
    changeWorkOrdersBetweenCouriersLabel:
      'İş emirlerinin rotaya dahil edilen dağıtıcılar arasında topluca değiştirilmesini sağlar.',
    assignAllWorkOrdersToAnotherCourier:
      'İş emirlerinin tamamını diğer dağıtıcıya ata.',
    assignAllWorkOrdersToAnotherCourierLabel:
      'İş emirlerinin tümünü bir dağıtıcıdan başka bir dağıtıcıya atamamızı sağlar. Dağıtıcılar aralarında değişiklik yapmaz, dağıtıcının üzerindekileri başkasına atar.',
    //assignAllWorkOrdersToAnotherCourierLabel: "İş emirlerinin tümünü bir dağıtıcıdan başka bir dağıtıcıya atamamızı sağlar. Dağıtıcılar aralarında değişiklik yapmaz, dağıtıcının üzerindekileri başkasına atar.Bu madde ile dağıtıcı değiştirildiğinde yeniden rotalama yapılması gerekmektedir.",
    splitWorkOrdersToOtherCouriers:
      'İş emirlerini diğer dağıtıcılara paylaştır.',
    splitWorkOrdersToOtherCouriersLabel:
      'Ataması yapılan iş emirlerini, rotalamaya dahil edilen ve edilmeyen herhangi bir dağıtıcıya tek tek paylaştırılmasını sağlar.',
    //splitWorkOrdersToOtherCouriersLabel: "Ataması yapılan iş emirlerini, rotalamaya dahil edilen ve edilmeyen herhangi bir dağıtıcıya tek tek paylaştırılmasını sağlar.Bu madde ile dağıtıcı değiştirildiğinde yeniden rotalama yapılması gerekmektedir.",
    targetCourierInfoNotFound: 'Hedef kurye bilgisi bulunamadı.',
  },
  complianceRate: 'Uyum Oranı',
  courierGroupDelete: 'Seçilen dağıtıcı grubu pasife alınacak.',
  deletedCourierGroup: 'Seçilen dağıtıcı grubu pasife alındı.',
  courierGroupAdd: 'Dağıtıcı Grubu Ekle',
  addedCourierGroup: 'Dağıtıcı grubu eklendi.',
  assignedSlots: 'Slot atamaları yapıldı.',
  editedCourierGroup: 'Dağıtıcı grubu düzenlendi.',
  courierGroupEdit: 'Dağıtıcı Grubu Düzenleme',
  courierGroupName: 'Dağıtıcı Grubu',
  validityStartDate: 'Başlangıç Tarihi',
  validityDates: 'Geçerlilik Tarihleri',
  validityEndDate: 'Bitiş Tarihi',
  startAndEndDate: 'Başlangıç - Bitiş Tarihi',
  courierList: 'Dağıtıcılar',
  courierGroupInfo: 'Dağıtıcı Grubu Bilgisi',
  pickDate: 'Tarih seçiniz',
  loadingLiveFeed: 'Araç datalarının yüklenmesi bekleniyor...',
  mainParameters: 'Ana Parametreler',
  operatingConditions: 'Çalışma Kuralları',
  willRunDynamicCapacity: 'Seçilen Zone için Dinamik Kapasite Çalıştırılsın',
  minimumRemainingTimeUntilNextSlot: "Sonraki Slot'a kalan minimum süre (dk)",
  maximumRemainingTimeUntilNextSlot: "Sonraki Slot'a kalan maksimum süre (dk)",
  fullnessRatio: 'Doluluk Oranı (%)',
  deliverySuccessRatio: 'Teslimat Başarı Oranı (%)',
  collectionSuccessRatio: 'Toplama Başarı Oranı (%)',
  durationBetweenOrder: 'Siparişler Arası Süre (dk)',
  runFrequency: 'Program Çalışma Frekansı (dk)',
  alertTime: 'Alarm Saati',
  temperature: 'Sıcaklık',
  yesterday: 'Dün',
  selectAllSlots: 'Tüm Slotları İşaretle/Kaldır',
  selectSlot: 'Slot Seçiniz',
  selectTaskId: 'Rotalama Id Seçiniz',
  yearMonthDay: 'YYYY-MM-DD',
  notAuthorized: 'Üzgünüz, bu sayfaya erişim yetkiniz bulunmamaktadır.',
  plate: 'Plaka',
  boxStatus: 'Kutu Statüsü',
  boxId: 'Kutu Kodu',
  boxDeliveryDate: 'Kutu Teslim Tarihi',
  manualReturn: 'Manuel Teslim',
  formatDayMonthYear: 'DD/MM/YYYY',
  returnManually: 'Manuel Teslim Et',
  boxStatusLost: 'LOST',
  number: 'Numara',
  numberOfSlotReleased: 'Dağıtıma Çıkılmış Slot Sayısı',
  numberOfSlotsScheduled: 'Planlanmış Slot Sayısı',
  allWarehouses: 'Tümü',
  orders: {
    refreshOrders: 'Siparişleri Yenile',
    locationValidated: 'Konum Doğrulandı',
    locationNotValidated: 'Konum Doğrulanamadı',
    hasFrozenProduct: 'Donuk Ürün İçeren Sipariş',
    waitingToPickup: 'Hacim Bilgisi İçin Toplama Bekleniyor',
    notFitInMotorcycle: 'Motorla Taşımaya Uygun Değil',
    motorVolume: 'Motor Hacmi',
  },
  vehiclePlanningReport: {
    reportName: 'AracPlanlamaRaporu.xlsx',
    taskId: 'Task Id',
    deliveryDate: 'Teslim Tarihi',
    distributionCenter: 'Dağıtım Merkezi',
    zone: 'Zone',
    slot: 'Slot',
    requestedVehicleCount: 'Seçilen Araç Sayısı',
    includedVehicleCount: 'Planlanan Araç Sayısı',
    actualVehicleCount: 'Dağıtıma Çıkan Araç Sayısı',
  },
  vehicleWorkHour: {
    warehouseName: 'Dağıtım Merkezi',
    workDate: 'Çalışma Günü',
    plateNumber: 'Plaka',
    zoneName: 'Zone Adı',
    workHour: 'Çalışma Saati',
    leaveType: 'İzin Tipi',
    leaveHour: 'İzin Saati',
    vehicleWorkHourEdit: 'Çalışma Takvimi Düzenleme',
    vehicleWorkHourAdd: 'Çalışma Takvimi Tanımlama',
    editedVehicleWorkHour: 'Çalışma Takvimi Düzenlendi',
  },
  enum: {
    PICKING: 'Toplanıyor',
    PICKED: 'Toplanmış',
    NOT_PICKED: 'Toplanmamış',
    tooltipPICKING: 'Sipariş Toplanıyor',
    tooltipPICKED: 'Siparişin Toplanması Tamamlandı',
    tooltipNOT_PICKED: 'Sipariş Henüz Toplanmadı',
    Slot: 'Slot',
    Return: 'İade',
    Replaced: 'Değişim',
    VAN: 'Araba',
    MOTORCYCLE: 'Motor',
    POSITIVE: 'Pozitif (+)',
    NEGATIVE: 'Negatif (-)',
    AND: 'VE',
    OR: 'VEYA',
    DEDICATED: 'Dedike',
    SPOT: 'Spot',
    WEEKLY: 'Haftalık',
    PAID: 'Ücretli',
    UNPAID: 'Ücretsiz',
    CUSTOMER_COMPLAINT: 'Müşteri Şikayeti',
    OTHER: 'Diğer',
  },
  placeholder: {
    startDate: 'Başlangıç Tarihi',
    endDate: 'Bitiş Tarihi',
    selectWarehouseDisplayReports: 'Raporları gösterilecek depoyu seçiniz!',
    searchOrder: 'Sipariş arama..',
    selectCourier: 'Dağıtıcı seçiniz!',
    selectSourceCourier: 'Kaynak dağıtıcıyı seçiniz!',
    selectTargetCourier: 'Hedef dağıtıcıyı seçiniz!',
    selectChangeReason: 'Değişiklik sebebini seçiniz!',
    selectOrders: 'Siparişleri seçiniz!',
    selectOperation: 'Yapmak istediğiniz işlemi seçiniz!',
    selectDate: 'Tarih Seçiniz!',
    day: 'Gün',
    month: 'Ay',
  },
  alert: {
    selectDateRange: 'Lütfen tarih aralığı seçiniz!',
    selectWarehouse: 'Lütfen depo seçiniz!',
    fillField: 'Lütfen bu alanı doldurunuz!',
    notValidEmail: 'Eposta adresi geçerli değil!',
    notValidPhone: 'Telefon numarası geçerli değil!',
    onlyPositiveValues: 'Paket paşına ücret negatif bir değer olamaz!',
    maxLengthExceeded: 'Maksimum karakter sayısını aştınız (max 64 karakter)!',
    maxLength10Character: 'Maksimum karakter sayısını aştınız (max 10 karakter)!',
    slotZoneRequired: 'Mağaza/Slot oluşturma seçenekleri zorunludur!',
    onlyNumbers: 'Değer rakam olmalıdır!',
    pleaseUploadExcelFile: 'Lütfen Excel dosyası yükleyiniz!',
  },
  NEW_ORDER: 'Yeni Sipariş',
  COLLECTING: 'Toplanıyor',
  SEMI_COLLECTED: 'Yarım Toplandı',
  COLLECTED: 'Toplama Tamamlandı',
  IN_TRANSIT: 'Dağıtımda',
  AT_CUSTOMER_ADDRESS: 'Müşteri Adresinde',
  DELIVERED: 'Teslim Edildi',
  NOT_DELIVERED: 'Teslim Edilemedi',
  ARRIVED_AT_STORE: 'Mağazaya Ulaştı',
  COMPLETED: 'Tamamlandı',
  REFUNDED: 'İade Edildi',
  ASSIGNED_TO_COURIER: 'Kuryeye Atandı',
  RETURN_REQUEST_RECEIVED: 'İade Siparişi Alındı',
  COURIER_ON_RETURN_PICKUP_WAY: 'Kurye iade siparişini üstlendi, yola çıktı',
  PICK_UP_AT_CUSTOMER: 'Kurye İade İçin Müşteri Adresinde',
  RETURN_PICKED_UP: 'Ürün müşteriden fiziksel alındı',
  RETURN_PICKUP_MISSED: 'Kurye vardı ama teslim alamadı',
  RETURN_PICKUP_COMPLETED: 'İade tamamlandı',
  RETURN_PICKUP_REJECTED: 'İade Reddedildi',
  RETURNED_TO_STORE: 'İade siparişi mağazaya Ulaştı',
  capacityPlanDashboard: 'Kapasite Plan Dashboard',
  courierPerfromanceDashboard: 'Dağıtıcı Performans Dashboard',
  session_expired: 'Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın',
  colorWhite: '#FFFFFF',
  orderInformation: 'Sipariş Bilgileri',
  watchRoute: 'Rota İzle',
  pleaseSelectSlot: 'Slot seçiminden sonra dağıtıcılar yüklenecektir.',
  deliveryStart: 'Dağıtım Başlangıç',
  deliveryEnd: 'Dağıtım Bitiş',
  deliveryCount: 'Teslimat Sayısı',
  hideShowOrders: 'Siparişleri Göster/Gizle',
  order: 'Sipariş',
  station: 'Durak',
  compliance: 'Uyum',
  inTransitCourierDashboard: ' - Dağıtımda',
  notInTransitCourierDashboard: ' - Dağıtımda Değil',
  totalDistance: 'Toplam Mesafe:',
  plannedDistance: 'Planlanan Mesafe:',
  traveledDistance: 'Gerçekleşen Mesafe:',
  orderCompletionPercentage: 'Sipariş Tamamlama Yüzdesi',
  selectSubZone: 'Sub zone seçiniz',
  blueColorCode: '#120A8F',
  timeWithSecond: 'Süre (DK)',
  usedApi: 'Kullanılan API',
  orderCount: 'Sipariş Sayısı',
  courierCount: 'Kurye Sayısı',
  distanceWithKm: 'Mesafe (KM)',
  parameterProfile: 'Parametre Profili',
  information: 'Bilgilendirme',
  planningDeliveryTime: 'Planlanan Teslim Saati',
  map: {
    airDistance: 'Kuş Uçuşu Mesafe:',
  },
  publicHoliday: {
    publicHolidayDelete: 'Seçilen tatil tanımı pasife alınacak',
    publicHolidayName: 'Resmi Tatil Adı',
    publicHolidayStartDate: 'Tarih',
    publicHolidayPeriod: 'İzin Süresi (Gün)',
    publicHolidayAdded: 'Resmi tatil eklendi',
    publicHolidayEdit: 'Resmi Tatil Düzenleme',
    publicHolidayAdd: 'Resmi Tatil Tanımlama',
    editedPublicHoliday: 'Resmi tatil düzenlendi',
    deletedPublicHoliday: 'Resmi tatil tanımı pasife alındı'
  },
  progressPayment: {
    invoice:'Fatura',
    progressPaymentLabel: 'Fatura Bilgileri',
    progressPaymentType: 'Fatura Tipi',
    otifValueTitle: 'OTIF Değeri (Günlük/Aylık)',
    otifDailyValue: 'Günlük OTIF',
    otifMonthlyValue: 'Aylık OTIF',
    ADVANCE_PAYMENT: 'İlk Hakediş',
    PROGRESS_PAYMENT: 'Ay Sonu Hakedişi',
    totalPrice: 'Kdv Hariç Tutar',
    price: 'Kdv Dahil Tutar',
    processId: 'İşlem No',
    processStatus: 'GIB Durumu',
    FAILED: 'Hatalı',
    IN_PROGRESS:  'İşlemde',
    SUCCESS: 'Başarılı',
    erpSentSucceeded: 'ERP Durumu',
    true: 'Gönderildi',
    false: 'Gönderilmedi',
    courierIdentityNumber1: 'İlk Hakediş Faturası TCKN',
    courierIdentityNumber2: 'Ay Sonu Hakediş Faturası TCKN',
    invoiceApprovalInfoTitle: 'Fatura Onay Bilgileri',
    invoiceApprovalProgressPaymentType: 'Onay Bekleyen Fatura Tipi',
    approvedUserId: 'Onaylayan Kullanıcı ID',
    approvedNameSurname: 'Onaylayan Ad Soyad',
    approvedDate: 'Onay Tarihi',
    approveProgressPaymentInvoice: 'Dönem Sonu Faturasını Onayla',
    approveAdvancePaymentInvoice: 'Avans Faturasını Onayla',
    invoiceApprovedSuccessfully: 'Fatura onaylandı',
  },
  taxPlate: 'Vergi Levhası',
  bankBook: 'Banka Hesap Cüzdanı',
  authorizedSignatures: 'İmza Beyannamesi',
  signatureCircular: 'İmza Sirküsü',
  vehicleRegistration: 'Ruhsat',
  criminalRecord: 'Adli Sicil Kaydı',
  carInsurance: 'Trafik Sigortası',
  driverLicense: 'Ehliyet',
  socialInsurance: 'Kurye İş Sözleşmesi',
  employmentAgreement: 'İşe Giriş Sözleşmesi',
  submit: 'Gönder',
  clear: 'Temizle',
  filter: 'Filtrele',
  ordersTitle: 'Siparişler',
  couriersTitle: 'Dağıtıcılar',
  vehicleGroupsTitle: 'Araç Grupları',
  totalCashFee: 'Kapıda Nakit',
  totalCreditCardFee: 'Kapıda Kredi Kartı',
  totalFee: 'Toplam',
  totalOtherFee: 'Diğer Ödemeler',
  totalVoucherFee: 'Cüzdan',
  totalMasterpassFee: 'Masterpass',
  totalGiftCardFee: 'Hediye Kartı/Kupon',
  MASTERPASS: 'Masterpass',
  CASH_ON_DELIVERY: 'Kapıda Nakit Ödeme',
  CASH_ON_DELIVERY_BY_CREDIT_CARD: 'Kapıda Kredi Kartı',
  PAYMENT_BY_VOUCHERS: 'Cüzdan',
  PAYMENT_BY_GIFT_CARD: 'Hediye Kartı ile Ödeme',
  OTHER_PAYMENTS: 'Diğer',
  GIFT_CARD: 'Hediye Kartı/Kupon',
  WALLET: 'Cüzdan',
  MANAGER: 'YONETICI',
  COLLECTOR: 'TOPLAYICI',
  REGIONAL_MANAGER: 'BÖLGE MÜDÜRÜ',
  STORE_MANAGER: 'MAĞAZA MÜDÜRÜ',
  REGIONAL_EXECUTIVE: 'BÖLGE YÖNETİCİSİ',
  CENTRAL_HR_EXECUTIVE: 'MERKEZİ İNSAN KAYNAKLARI YÖNETİCİSİ',
  BRANCH_MANAGER: 'ŞUBE MÜDÜRÜ',
  CENTRAL_OPERATIONS_OFFICER: 'MERKEZİ OPERASYON MEMURU',
  REGIONAL_HR_EXECUTIVE: 'BÖLGE IK YÖNETİCİSİ',
  LOGISTICS_EXECUTIVE: 'LOJİSTİK YÖNETİCİSİ',
  ECOM_OPERATIONS_SPECIALIST: 'E-TİCARET OPERASYON UZMANI',
  NOT_ECOM_STORE_MANAGER: 'E-TİCARETE KAPALI MAĞAZA YÖNETİCİSİ',
  CENTRAL_OPERATIONS_EXECUTIVE: 'MERKEZİ OPERASYON YÖNETİCİSİ',
  CENTRAL_OPERATIONS_VIEWER: 'MERKEZ GÖRÜNTÜLEME',
  COURIER: 'DAĞITICI',
  REGIONAL_DIRECTOR: 'REGİONAL DİRECTOR',
  STORE_SALER: 'MAĞAZA SATIŞ TEMSİLCİSİ',  
  BRANCH_MANAGER_SUPPORTER: 'ŞUBE MÜDÜRÜ VEKİLİ',  
  REGIONAL_MANAGER_SUPPORTER: 'BÖLGE MÜDÜRÜ VEKİLİ',  
  REGIONAL_EXECUTIVE_SUPPORTER: 'BÖLGE YÖNETİCİSİ VEKİLİ',  
  BUDDY_MANAGER_CANDIDATE: 'YÖNETİCİ ADAYI (BUDDY)',  
  STORE_MANAGER_2_0: 'MAĞAZA YÖNETİCİSİ - 2.0',  
  STORE_MANAGER_CANDIDATE: 'YÖNETİCİ ADAYI - MY',  
  STORE_MANAGER_SUPPORTER: 'MAĞAZA YÖNETİCİ YARDIMCISI',  
  STORE_MANAGER_SUPPORTER_MINI: 'MAĞAZA YÖNETİCİ YARDIMCISI MİNİ',  
  STORE_MANAGER_SUPPORTER_CANDIDATE: 'YÖNETİCİ ADAYI - MYY',  
  STORE_SALER_PART_TIME: 'MAĞAZA SATIŞ TEMSİLCİSİ PART TIME',  
  STORE_SALER_MINI: 'MAĞAZA SATIŞ TEMSİLCİSİ MİNİ',  
  STORE_SALER_SEASON: 'MAĞAZA SATIŞ TEMSİLCİSİ SEZONLUK',  
  STORE_SALER_MANAGER_CANDIDATE: 'YÖNETİCİ ADAYI - MST',  
  NOT_ECOM_USER: 'E-TİCARET KULLANICISI DEĞİL',  
  NOT_ECOM_STORE_SALER: 'E-TİCARET DIŞI MAĞAZA SATIŞ TEMSİLCİSİ',  
  NOT_ECOM_BUDDY_MANAGER_CANDIDATE: 'E-TİCARET DIŞI YÖNETİCİ ADAYI (BUDDY)',  
  NOT_ECOM_STORE_MANAGER_2_0: 'E-TİCARET DIŞI MAĞAZA YÖNETİCİSİ - 2.0',  
  NOT_ECOM_STORE_MANAGER_CANDIDATE: 'E-TİCARET DIŞI YÖNETİCİ ADAYI - MY',  
  NOT_ECOM_STORE_MANAGER_SUPPORTER: 'E-TİCARET DIŞI MAĞAZA YÖNETİCİ YARDIMCISI',  
  NOT_ECOM_STORE_MANAGER_SUPPORTER_MINI: 'E-TİCARET DIŞI MAĞAZA YÖNETİCİ YARDIMCISI MİNİ',  
  NOT_ECOM_STORE_MANAGER_SUPPORTER_CANDIDATE: 'E-TİCARET DIŞI YÖNETİCİ ADAYI - MYY',  
  NOT_ECOM_STORE_SALER_PART_TIME: 'E-TİCARET DIŞI MAĞAZA SATIŞ TEMSİLCİSİ PART TIME',  
  NOT_ECOM_STORE_SALER_MINI: 'E-TİCARET DIŞI MAĞAZA SATIŞ TEMSİLCİSİ MİNİ',  
  NOT_ECOM_STORE_SALER_SEASON: 'E-TİCARET DIŞI MAĞAZA SATIŞ TEMSİLCİSİ SEZONLUK',  
  NOT_ECOM_STORE_SALER_MANAGER_CANDIDATE: 'E-TİCARET DIŞI YÖNETİCİ ADAYI - MST',  
  NOT_ECOM_BRANCH_MANAGER_SUPPORTER: 'E-TİCARET DIŞI ŞUBE MÜDÜRÜ VEKİLİ',  
  NOT_ECOM_REGIONAL_MANAGER_SUPPORTER: 'E-TİCARET DIŞI BÖLGE MÜDÜRÜ VEKİLİ',  
  NOT_ECOM_REGIONAL_EXECUTIVE_SUPPORTER: 'E-TİCARET DIŞI BÖLGE YÖNETİCİSİ VEKİLİ',
  NOT_APPROVED: 'Onaylanmadı',
  NEW: 'Yeni',
  HAS_NEW_VERSION_FOR_APPROVAL: 'Onay Bekleyen Yeni Versiyon',
  CANCELLED: 'İptal Edildi',
  ON_HOLD: 'BEKLEMEDE',
  IN_DISTRIBUTION: 'DAĞITIMDA',
  ONLINE: 'ÇEVRİMİÇİ',
  OFFLINE: 'ÇEVRİMDIŞI',
  productImage: 'Ürün Resmi',
  productCode: 'Ürün Kodu',
  excessTotal: 'Fazla Toplama',
  missingTotal: 'Eksik Toplama',
  productEdit: 'Ürün Düzenleme',
  productPrice: 'Ürün Fiyatı',
  overCollectionPercentage: 'Fazla Toplama Yüzde Oranı',
  underCollectionPercentage: 'Eksik Toplama Yüzde Oranı',
  open: 'Açık',
  close: 'Kapalı',
  editedOrderItemProperty: 'Gramajlı ürün düzenlendi.',
  totalOrderCount: 'Günlük Dağıtıma Çıkarılan Sipariş Adedi',
  notDeliveredOrderCount: 'Teslim Edilemeyen Sipariş Adedi',
  firstPackageTakingTime: 'İlk Siparişinin Teslim Alınma Tarihi',
  lastPackageDeliverTime: 'Son Siparişinin Teslim Edilme Tarihi',
  timeDiff: 'İki Sipariş Arasında Geçen Saat Aralığı',
  statusActivated: 'Kayıt Başarıyla Aktif Edildi.',
  zoneActiveQuestion:
    'Bu zone’u aktif hale getirmek istediğinize emin misiniz?',
  zonePassiveQuestion:
    'Bu zone’u pasif hale getirmek istediğinize emin misiniz?',
  externalCreateTimeGe: 'Oluşturma Tarihi Başlangıcı',
  externalCreateTimeLe: 'Oluşturma Tarihi Sonu',
  currentNumber: 'Cari No',
  bringCompetitorStores: 'Rakip Mağazaları Getir',
  arrivedCompetitorStores: 'Rakip Mağazalar Geldi',
  cleanCompetitorStores: 'Rakip Mağazaları Temizle',
  zoneMove: 'Bölgeyi Taşı',
  zoneRevert: 'Bölgeyi Geri Al',
  zoneRevertMessage: 'Bu bölgeyi eski mağazaya geri aktarmak istiyor musunuz?',
  expandMap: 'Haritayı Genişlet',
  showList: 'Listeyi Göster',
  values: 'Değerler',
  distanceLimit: 'Uzaklık Kontrolü (metre)',
  leastOneSlotMessage: 'Lütfen en az bir güne minimum bir slot ekleyiniz !!!',
  dontLeaveSpace: 'Lütfen boşluk bırakmayınız.',
  dataNotSavedWarningMessage:
    'Yaptığınız değişiklikler kaydedilmeyecek. Devam etmek istiyor musunuz?',
  searchAcrossTurkey: 'Tüm Türkiye’de Ara',
  acrossTurkey: 'Tüm Türkiye',
  selectedOrderCount: 'Seçilen Sipariş',
  totalOrderCountForRouting: 'Toplam Sipariş',
  orderSearch: 'Sipariş Ara',
  selectedCourierCount: 'Seçilen Dağıtıcı',
  totalCourierCountForRouting: 'Toplam Dağıtıcı',
  courierSearch: 'Dağıtıcı Ara',
  delay: 'Gecikme',
  containsFrozen: 'Donuk Ürün İçeren Sipariş',
  fastDelivery: 'Hızlı Teslimat',
  fastDeliveryDuration: 'Hemen Teslimat Slot Süresi (dk)',
  eliteCustomer: 'Elit Müşteri',
  collected: 'Toplandı',
  collecting: 'Toplanıyor',
  notCollected: 'Toplanmadı',
  orderStatus: 'Sipariş Durumu',
  selectAllCurrentOrders: 'Güncel Siparişlerin Tümünü Seç',
  showPastOrders: 'Geçmiş Siparişleri Göster',
  addressLocation: 'Sipariş Lat/Lon',
  storeLocation: 'Mağaza Lat/Lon',
  storeLongitude: 'Mağaza Lon',
  storeLatitude: 'Mağaza Lat',
  addressLatitude: 'Sipariş Lat',
  addressLongitude: 'Sipariş Lon',
  estimatedDistance: 'Tahmini Mesafe (m)',
  distributionStartDate: 'Dağıtım Başlangıç Tarihi',
  plannedActualDistance: 'Planlanan/Gerçekleşen Mesafe',
  deliveryCompletionPercentage: 'Teslimat Tamamlama Yüzdesi',
  distributionStartEndDate: 'Dağıtım Başlangıç/Bitiş Zamanı',
  scheduledDeliveryDate: 'Planlanan Teslimat Tarihi',
  happeningDeliveryDate: 'Gerçekleşen Teslimat Tarihi',
  district: 'İlçe',
  isOpen: 'Açık mı?',
  ccStatus: 'CC Durumu',
  ecomStatus: 'ECOM Statü',
  faxNumber: 'Fax Numarası',
  phoneNumber2: 'Telefon Numarası 2',
  shipmentType2: 'Sevkiyat Yöntemi',
  list: 'Listele',
  excelImportExport: 'Excel İçe Aktar/ Dışa Aktar',
  listOrCalender: 'Takvim / Liste Görünümü',
  maxSelectedDateRange: 'Maksimum Seçilebilecek Tarih Aralığı 30 Gündür.',
  maxSelectedDateRangeTwoDays: 'Maksimum Seçilebilecek Tarih Aralığı 2 Gündür.',
  obaseStatus: 'Obase Sipariş Statüsü',
  deliveryType: 'Teslimat Tipi',
  CARD_ON_DELIVERY: 'Kapıda Kredi Kartı ile Ödeme',
  home_code: 'Eve teslimat',
  FAST: 'Hemen',
  CARGO: 'Kargo',
  SLOT: 'Randevulu',
  IN_STORE: 'Mağazadan teslim al, tıkla gel al',
  NO_SHIPMENT:
    'Herhangi Bir Operasyon Yapılmauacak(Kızılay Kolisi, Deprem Yardımı)',
  authorizedName: 'Yetkili Adı',
  authorizedNumber: 'Yetkili No',
  authorizedNumber2: 'Yetkili No 2',
  authorizedMail: 'Yetkili Mail',
  roleMail: 'Mail',
  branchName: 'Şube Adı',
  branchManager: 'Şube Yöneticisi',
  branchManagerMail: 'Şube Yöneticisi Mail',
  branchManagerPhoneNum: 'Şube Yöneticisi Telefon Numarası',
  branchManagerPhoneNum2: 'Şube Yöneticisi Tel',
  branchCode: 'Şube Kodu',
  deliveryModel: 'Sevkiyat Yöntemleri',
  paymentMethod: 'Ödeme Yöntemleri',
  collectionType: 'Toplama Tipi',
  alternativeProduct: 'Alternatif Ürün',
  isAlternativeProduct: 'Alternatif ürüne uygun mu?',
  regionInfo: 'Bölge Bilgileri',
  branchInfo: 'Şube Bilgileri',
  CLOSED: 'KAPALI',
  TEMPORARY_CLOSED: ' GEÇİCİ KAPALI',
  WAITING: 'BEKLEMEDE',
  OPEN: 'AÇIK',
  BAG: 'POŞET',
  BOX: 'KUTU',
  editedStore: 'Mağaza düzenlendi.',
  CALCULATING: 'Rota Hesaplanıyor',
  DISTRIBUTION_STARTED: 'Devam Ediyor',
  DISTRIBUTION_COMPLETED: 'Rota Tamamlandı',
  ERROR: 'Rota Hesaplanamadı',
  routingSolveStatus: 'Rota Durumu',
  routingStartTime: 'Başlangıç Zamanı',
  routingDoneTime: 'Tamamlanma Zamanı',
  routeStartTime: 'Başlangıç Zamanı',
  routeEndTime: 'Tamamlanma Zamanı',
  routingStartAndDoneTime: 'Başlangıç ve Tamamlanma Zamanı',
  startTime: 'Başlangıç Zamanı',
  endTime: 'Bitiş Zamanı',
  orderDate: 'Sipariş Tarihi',
  doYouConfirm: 'Onaylıyor musunuz?',
  youHavePastOrders:
    'Seçmiş olduğunuz siparişler {{slotString}} slotu için rotalancaktır, onaylıyor musunuz?',
  distributionStartTime: 'Dağıtıma Başlangıç Saati',
  numberOfOrdersCarried: 'Taşınan Sipariş Sayısı',
  CLOSE: 'Kapalı',
  PENDING: 'Beklemede',
  TEMPORARILY_CLOSED: 'Geçici Kapalı',
  routesSelectedWillDeleted: 'Seçmiş olduğunuz rotalar silinecek !!!',
  areYouSureRoutesSelectedWillDeleted:
    'Seçmiş olduğunuz ilgili rotalar silinecektir. Onaylıyor musunuz?',
  plannedRouteEndTime: 'Planlanan Tamamlanma Zamanı',
  completedAndTotalOrders: 'Tamamlanan / Toplam Sipariş',
  slotStartDate: 'Slot Başlangıç Zamanı',
  slotEndDate: 'Slot Bitiş Zamanı',
  noData: 'Veri bulunamadı!',
  orderStatusReport: 'Sipariş Durum Raporu',
  orderDeliveryDate: 'Sipariş Dağıtım Tarihi',
  orderPlacementDate: 'Sipariş Verilme Tarihi',
  orderSlot: 'Sipariş Slotu',
  customerFullName: 'Müşteri Adı Soyadı',
  customerPhoneNumber: 'Müşteri Tel',
  customerId: 'Müşteri ID',
  cancelReturnStatus: 'İptal/İade Durumu',
  cancellationReason: 'İptal Sebebi',
  nonDeliveryReason: 'Teslim Edilememe Sebebi',
  collectionStartDate: 'Toplama Başlangıç Tarihi',
  collectionEndDate: 'Toplama Bitiş Tarihi',
  collectionTime: 'Toplama Süresi (dk)',
  courierDeliveryDate: 'Kuryeye Teslim Tarihi',
  customerDeliveryDate: 'Müşteriye Teslim Tarihi',
  deliveryTime: 'Teslimat Süresi (dk)',
  totalPrice: 'Toplam Tutar (TL)',
  refundedPrice: 'Toplam İade Edilen Tutar (TL)',
  refundAmountForUnavailableProduct: 'Toplanmayan Ürünlerin İade Tutarı (TL)',
  partialRefundAmount: 'Eksik Gramaj Toplama ve Poşet İade Tutarı (TL)',
  customerCollectedAmount: 'Müşteriden Teslim Alınan Tutar',
  collectorFullName: 'Toplayıcı',
  courierFullName: 'Dağıtıcı',
  coordinatesOfCustomer: 'Müşteri Koordinatları',
  orderNumber: 'Sipariş Numarası',
  returnOrder: 'İade Sipariş',
  mainZone: 'Ana Zone',
  zoneType: 'Zone Tipi',
  zoneStatus: 'Zone Durumu',
  note: 'Not',
  isMainZone: 'Ana Zone mu?',
  today: 'Bugün',
  tomorrow: 'Yarın',
  confirmDeleteRow: 'Bu satırı silmek istediğinize emin misiniz?',
  enterCapacity: 'Lütfen kapasite giriniz!',
  occupancy: 'Doluluk Oranı',
  slotsEdited: 'Slotlar düzenlendi.',
  orderDeliveryDateRange: 'Sipariş Dağıtım Tarih Aralığı',
  orderChannel: 'Sipariş Kanalı',
  capacityOnlyPositiveValues: 'Lütfen kapasiteyi pozitif bir sayı giriniz!',
  REGULAR: 'Kadrolu',
  validityDate: 'Geçerlilik Tarihi',
  targetRegion: 'Hedef Bölge',
  targetGroup: 'Hedef Kitle',
  orderCity: 'Sipariş İli',
  CRAFTMAN: 'Esnaf',
  templateName: 'Şablon Adı',
  mainTemplate: 'Ana Şablon',
  isMainTemplate: 'Ana Şablon mu?',
  selectStatus: 'Durum Seçiniz',
  newTemplate: 'Yeni Şablon Oluşturma',
  invoice: 'Fatura',
  pricing: 'Ücretlendirme',
  MONTHLY: 'Aylık',
  billingFrequency: 'Fatura Frekansı',
  invoiceType: 'Fatura Tipi',
  invoiceTime: 'Fatura Zamanı',
  fixedWage: 'Standart Ücret',
  fixedVestingMethod: 'Hakediş Yöntemi',
  fixedVestingTemplateName: 'Hakediş Şablonu Adı',
  perOrder: 'Sipariş Bazında',
  eInvoice: 'E-Fatura',
  minPieceGreaterThanMaxPiece: 'Min Adet Max Adetten büyük olamaz!',
  minPiece: 'Minimum Adet',
  maxPiece: 'Maksimum Adet',
  maxPieceMustBeGreaterThanMinPiece:
    'Max Adet Min Adetten büyük olmalıdır!',
  priceMustBeGreaterThanPrevious: 'Fiyat önceki fiyattan büyük olmalıdır!',
  WORKING_HOURS: 'ÇALIŞMA SAATİ',
  CUSTOMER_SATISFACTION: 'MÜŞTERİ MEMNUNİYETİ',
  MIN_WORK_HOUR: 'MIN ÇALIŞMA SAATİ',
  PAY_DAY_APPLICATION_ACTIVITY: 'MAAŞ GÜNÜ BAŞVURU FAALİYETİ',
  DAYS: 'GÜNLÜK',
  HOURS: 'SAATLİK',
  valueMustBeBetween1And24: 'Değer 1 ile 24 arasında olmalıdır!',
  valueMustBeBetween1And28: 'Değer 1 ile 28 arasında olmalıdır!',
  ORDER_COUNT: 'Sipariş Bazında',
  WORKING_HOURS: 'Saatlik Hakediş',
  workingHoursPrice: 'Saatlik Hakediş Tutarı',
  dailyMaximumPrice: 'Günlük Kazanılabilecek Maksimum Hakediş Tutarı',
  ELECTRONIC: 'E-Fatura',
  templateWillBeValid: 'Şablonun Geçerli Olacağı',
  cities: 'İller',
  EXPEDITION_COUNT: 'Sefer Sayısı',
  ANNUAL: 'Yıllık',
  description: 'Açıklama',
  closedDates: 'Kapalı Günler',
  addClosedDate: 'Kapalı Gün Ekle',
  addedClosedDate: 'Kapalı gün eklendi.',
  deletedClosedDate: 'Kapalı gün silindi.',
  closedDateDelete: 'Kapalı gün silinecek.',
  closeDateDeleted: 'Kapalı gün silindi.',
  extraVesting: 'Ek Hakediş',
  calculatingType: 'Hesaplama Tipi',
  gradualNormal: 'Kademeli / Normal',
  addRule: 'Kural Ekle',
  specialProduct: 'Özel Ürün',
  productID: 'Ürün ID',
  addToProduct: 'Ürün Ekle',
  SINGLE_ORDER: 'SIPARİŞ BAZINDA',
  ALL_ORDERS: 'TÜM SİPARİŞLER',
  SINGLE_PRODUCT: 'URUN BAZINDA',
  minWorkTime: 'Min. Çalışma Saati',
  advanceDayActiveControl: 'Avans Günü Aktiflik Kontrolü',
  advance: 'Avans',
  advanceFrequency: 'Avans Frekansı',
  advanceTime: 'Avans Zamanı',
  advancePrice: 'Avans Ücreti',
  advanceRule: 'Avans Kuralı',
  storeGroups: 'Şubeler',
  slotCapacityImport: 'Slot Kapasite İçe Aktar',
  infoForSlotCapacityImport:
    'Doğru formatta data yüklemek için örnek şablondaki Açıklama sayfasını inceleyiniz.',
  infoForSlotCapacityImport1:
    'İlgili dosyayı yükledikten sonra kayıtlarınız anında sisteme işlenmeyebilir. İşlemin durumu veya dosyadaki dataların hata verip vermediği ile alakalı farklı bir ekrandan takibi yapılabilir.',
  fileTransferStarted: 'Dosya aktarımı başlatılmıştır. ',
  boxShelfInfo: 'Kutu/Raf',
  changeStatus: 'Statü Değiştir',
  orderStatusChanged: 'Sipariş Statüsü Değiştirildi',
  doYouConfirmChangeOrderStatus:
    'İlgili sipariş {{statusTranslate}} yapılacaktır, onaylıyor musunuz?',
  CITY: 'ŞEHİR',
  REGION: 'BÖLGE',
  editedProgressPaymentTemplate: 'Hakediş Düzenlendi',
  addedProgressPaymentTemplate: 'Hakediş Kaydedildi',
  youMustHaveAtLeast2Grades: 'Kademeli Hakediş Artışı En Az 2 Tane Olmalıdır!',
  progressPaymentStatus: 'Hakediş Statüsü',
  period: 'Dönem',
  advancePayment: 'Avans Hakedişi',
  orderQuantity: 'Sipariş adedi',
  workHour: 'Çalışma Saati',
  fixedProgressPaymentAmount: 'Sabit Hakediş Tutarı (TL)',
  additionalProgressPaymentAmount: 'Ek Hakediş Tutarı (TL)',
  template: 'Şablon',
  DRAFT: 'Taslak',
  WAITING_FOR_INVOICE: 'Fatura Bekleniyor',
  WAITING_FOR_APPROVAL: 'Onay Bekleniyor',
  APPROVED: 'Onaylandı',
  REJECTED: 'Reddedildi',
  orderAmount: 'Sipariş Tutarı (TL)',
  courierPhone: 'Kurye Tel',
  overDistanceAmount: 'Ek KM Tutarı (TL)',
  overDistanceQuantity: 'Ek KM Miktarı',
  overDeciAmount: 'Desi Tutarı (TL)',
  overDeciQuantity: 'Ek Desi Miktarı',
  specialProductQuantity: 'Özel Ürün Miktarı',
  specialProductAmount: 'Özel Ürün Tutarı (TL)',
  totalOrder: 'Toplam Sipariş',
  progressPaymentCourierDetail: 'Dağıtıcı Hakediş Detayı',
  showDetails: 'Detayları Göster',
  progressPaymentAmount: 'Hakediş Tutarı (TL)',
  specialProductQuantity2: 'Özel Ürün Adedi',
  bulkDefinitionTracing: 'Toplu Tanım İzleme',
  IN_PROGRESS: 'Devam Ediyor',
  actionID: 'İşlem ID',
  loadingTime: 'Yükleme Zamanı',
  uploadedBy: 'Yükleyen',
  numberOfSuccessfulRegistrations: 'Başarılı Kayıt Sayısı',
  totalNumberOfRecords: 'Toplam Kayıt Sayısı',
  file: 'Dosya',
  success: 'Başarılı',
  orderDateOfDelivery: 'Sipariş Teslim Tarihi',
  airDistance: 'Kuş Uçuşu Mesafe (m)',
  categoryCode: 'Kategori Kodu',
  categoryName: 'Kategori Adı',
  pickingOrder: 'Reyon Sırası',
  storeBasedSections: 'Mağaza Bazlı Reyolar',
  importBasedSectionModalMessage:
    'Toplu yükleme/güncelleme yapmak için örnekte bulunan formatta bir Excel yüklemeniz gerekmektedir',
  reqMin1AdvanceRule: 'En az 1 adet avans kuralı olmalıdır!',
  importBulkStoreInfo: 'Toplu Mağaza Bilgilerini Güncelleme',
  importStoreInfoMessage:
    'Toplu yükleme yapmak için örnekte bulunan formatta formatta bir Excel yüklemeniz gerekmektedir. Eğer toplu güncelleme yapmak isterseniz mağaza kodu alanının dolu olması gerekmektedir. Mağaza kodu boş olduğu olduğu takdirde düzenleme yapılamayacaktır.',
  imporAllZoneUpdateInfo: 'Toplu Zone Bilgilerini Güncelleme',
  importAllZoneUpdateMessage1: 'Toplu yükleme yapmak için örnekte bulunan formatta formatta bir Excel yüklemeniz gerekmektedir.',  
  importAllZoneUpdateMessage2: 'Eğer toplu güncelleme yapmak isterseniz mağaza kodu, zone ismi ve zone kodu alanlarının dolu olması gerekmektedir.',
  importAllZoneUpdateMessage3: 'Mağaza kodu, zone ismi ve zone kodu alanları boş olduğu olduğu takdirde düzenleme yapılamayacaktır.',
  reqSlotTemplateOrZone: 'Lütfen Slot Şablonu veya Zone Seçiniz!',
  slotTemplateZoneListPage: 'Slot Şablonu Zone Listesi',
  searchByZoneOrSlotTemplateOnly: 'Sadece Zone veya Şablon ile Ara',
  enterAFewLettersForZoneSearch:
    "Seçmek istediğiniz Zone'u bir kaç harfle giriniz",
  enterAFewLettersForStoreSearch:
    'Seçmek istediğiniz mağazayı bir kaç harfle giriniz',
  editAndDelete: 'Düzenle/Sil',
  nameSurname: 'Ad Soyad',
  slotNotFound: 'Slot bulunamadı!',
  slotName: 'Şablon Adı',
  goToSlots: 'Slotlarına Git',
  goToZones: 'Zonelarına Git',
  storeDailyStatus: 'Mağaza Günlük Statü',
  capacityShouldBeGreaterThanCurrentOrderCount:
    'Kapasite, mevcut sipariş sayısından küçük olamaz!',
  orderTransfer: 'Sipariş Transferi',
  targetStore: 'Hedef Mağaza',
  transferOrder: 'Siparişi Transfer Et',
  orderTransferred: 'Sipariş Transferi gerçekleştirildi.',
  saveEdit: 'Düzenlemeyi Kaydet',
  collapseWarningMessage:
    'Herhangi bir işlem yapmayacaksanız menüyü kapatıp, işleme devam ediniz!',
  storeManagement: 'Mağaza Yönetimi',
  branchNameAndCode: 'Şube Kodu - Adı',
  authorizedPerson: 'Yetkili',
  authorizedRole: 'Yetkili Rolü',
  enterValue: 'Bu alan boş olamaz, bir değer giriniz!',
  enterValidTimeRange: 'Geçerli bir tarih aralığı giriniz!',
  changedSlotNotFound: 'Düzenlenecek slot bulunamadı!',
  addSlot: 'Yeni Slot Ekle',
  lastTransactionDate: 'Son İşlem Tarihi',
  sellerSource: 'Satış Kaynağı',
  transactionType: 'İşlem Tipi',
  transactionSource: 'İşlem Kaynağı',
  transactionQuantity: 'Satılabilir Stok İşlem Miktarı',
  stockTransactionQuantity: 'Stok İşlem Miktarı',
  currentQuantity: 'Stok Miktarı',
  currentFreeQuantity: 'Satılabilir Stok Miktarı',
  maxSelectedDateRangeSevenDays:
    'Maksimum Seçilebilecek Tarih Aralığı 7 Gündür.',
  reportLinkSentMailMessage:
    'Sistemde tanımlı mail adresinize rapor linki gönderilecektir.',
  ecomParameters: 'ECOM Parametreleri',
  activeProduct: 'Aktif Ürün',
  lastAndFirstUpdateProductDate: 'Ürün İlk/Son Güncelleme Tarihi',
  countOfStockedProducts: 'Stoklu Ürün Sayısı',
  stockUpdateDate: 'Stok Güncelleme Tarihi',
  openForSale: 'Satışa Aç',
  successOpenedForSale: 'Başarılı bir şekilde satışa açıldı.',
  EACH: 'Adet',
  transactionDate: 'İşlem Tarihi',
  productUnitType: 'Ürün Birim Tipi',
  totalStockAmount: 'Toplam Stok Miktarı',
  sellableStockAmount: 'Satılabilir Stok Miktarı',
  goToStockTransactions: 'Stok İşlemlerine Git',
  INTEGRATION: 'Entegrasyon',
  STOCK_CREATED_OR_UPDATED_INTEGRATION:
    ' Entegrasyon Stok Gönderimi /Güncelleme',
  STOCK_CREATED_OR_UPDATED: ' Stok Gönderimi veya Güncelleme',
  FAILED: 'Ödeme Alınamadı',
  COLLECTION_COMPLETED: 'Toplama Tamamlandı',
  ADDITIONAL_ORDER: 'Ek Sipariş',
  CANCELLED_BY_COURIER: 'Kurye Tarafından İptal Edildi',
  ORDER_SHIPMENT_TRANSFERRED: 'Sipariş Transferi',
  ECOMMERCE: 'Ecommerce',
  MOBILIVA: 'Mobiliva',
  OBASE: 'Obase',
  OBASE_RESULT: 'Obase Sonuç',
  operationCode: 'İşlem Kodu',
  enterOrderNumOrObaseId: "Sipariş No veya OBASE işlem ID'si giriniz!",
  generateSlot: 'Slot Oluştur',
  selectSlotTemplate: 'Slot Şablonu Seçiniz',
  slotsGenerated: 'Slotlar başarılı bir şekilde oluşturuldu.',
  selectSlotTemplateForThisZone:
    "kodlu zone'a slot oluşturmak için Slot Şablonu seçiniz.",
  activeRegionStoreSelection: 'Aktif Mağaza/Bölge Seçimi',
  assignSlotsTargetZone: 'Hedef Mağazadaki Zone\'un Slotları Atansın',
  zoneToUseSlots: 'Slotları Kullanılacak Zone',
  generateSlotWithTemplate: 'Şablon eşleştirerek Slot Oluştur',
  moveCourier: 'Dağıtıcı Taşıma',
  areMoveCouriers: 'Dağıtıcılar Taşınsın mı?',
  zoneRegionMove: 'Zone Bölge Taşıma',
  selectStoreMovingFrom: 'Taşıma işlemi yapacağınız mağazayı seçiniz.',
  slotTemplate: 'Slot Şablonu',
  zoneMoveCompleted: 'Zone taşıma işlemi gerçekleştirildi.',
  availableForBulkSale: 'Toplu Satışa Aç',
  FIXED_PRICE: 'Sabit Fiyat',
  PROGRESS_PAYMENT_RELATED: 'Oluşan Hakediş Tutarı Kadar',
  kmProgressPaymentAmount: 'KM Hakediş Tutarı (TL)',
  desiProgressPaymentAmount: 'Desi Hakediş Tutarı (TL)',
  confirmSelected: 'Seçilenleri Onayla',
  rejectSelected: 'Seçilenleri Reddet',
  confirmSelectedMessage: 'Seçilenleri onaylamak istediğinize emin misiniz?',
  rejectSelectedMessage: 'Seçilenleri reddetmek istediğinize emin misiniz?',
  canceledQuantity: 'İptal Edilen Adet',
  reasonForCancellation: 'İptal Nedeni',
  cancelingPerson: 'İptal Eden Kişi',
  cancellationDate: 'İptal Tarihi',
  suitableForPaymentAtDoor: "Kapıda ödemeye uygun mu ?",
  SOK_POSITIVE: "SOK-POSITIVE",
  SOK_ECOM: "SOK-YENI ECOM",
  TRANSFERRED: "Transfer Edildi",
  forbiddenRolesForUserEditMessage:"Bu role ait bilgiler entegrasyon ile gelmektedir. Bu ekranda sadece kullanıcının şifresini düzenleyebilirsiniz. Diğer alanlar bilgilendirme amaçlıdır.",
  minGramGreaterThanMaxGram: 'Min Gram Bir önceki Max Gramdan Büyük Olamalıdır!',
  maxGramMustBeGreaterThanMinGram: 'Max Gram Min Gramdan Büyük Olmalıdır!',
  overWeightAmount: "KG Hakediş Tutarı (TL)",
  overWeightQuantity: "KG Miktarı",
  missingNotificationDate: "Eksik Bildirim Tarihi",
  currentFreeQuantityAtCancellation: "İptal Anındaki Satılabilir Stok ",
  actualFreeQuantity: "Güncel Satılabilir Stok",
  cancelledDate: "İptal Tarihi",
  goToDetail: 'Detaya Git',
  isContainingFrozenProduct: "Donuk Ürün İçeriyor Mu",
  isAvailableExstraPayment: "Fazla ödeme alınabilir mi",
  alternativeProductSelection: "Alternatif Ürün Tercihi",
  notRequested: "İstenmiyor",
  requested: "İsteniyor",
  callMe: "Aranacak",
  fromStore: "Mağazadan Teslim",
  finalTotalPrice: "Sipariş Son Tutarı",
  paymentDetail: "Ödeme Detayı",
  erpCode: "ERP Kodu",
  cityAndDistrict: "İl-İlçe",
  collectedQuantity: "Toplanan Miktar",
  orderItemQuantity: "Sipariş Miktarı",
  myProfile: "Profilim",
  clickToUpdatePassword: "Şifrenizi güncellemek için tıklayınız.",
  currentPassword: "Mevcut Şifre",
  twoPasswordNotEqual: "Girdiğiniz iki şifre eşleşmiyor!",
  updatedPasswordAgainLogin: "Şifreniz başarılı ile değiştirilmiştir. Tekrardan giriş yapmalısınız",
  searchAllUsers: "Tüm Kullanıcılarda Ara",
  alternativeToWhat: "Neyin Alternatifi",
  newOrderQuantity: "Sipariş Anındaki Satılabilir Stok",
  monthly: "Aylık",
  daily: "Günlük",
  generalPerformance: "Genel Performans",
  target: "Hedef",
  ON_TIME_AND_COMPLETE_COLLECTION: 'Zamanında ve Eksiksiz Toplama',
  COMPLETE_COLLECTION: 'Eksiksiz Toplama',
  ON_TIME_COLLECTION: 'Zamanında Toplama',
  ON_TIME_DELIVERY: 'Zamanında Teslimat',
  OTIF: 'Eksiksiz ve Zamanında Teslimat',
  CANCELLATION_AND_RETURN: 'İptal ve İade',
  kpiWarningMessage: "KPI verilerini görmek için mağaza seçimi yapınız !!! ",
  updateKpiDataMessage: "KPI verileri 5 dk aralıklarla ile güncellenmektedir.",
  dataLoading: "Veri Yükleniyor...",
  DELAYED_COLLECTION_ON_TIME: 'Toplama Bekleyen Riskli siparişler',
  DELAYED_AND_WAITING_FOR_COLLECTION: 'Zamanında Toplaması Geciken Siparişler',
  DELAYED_BY_WAITING_FOR_COURIER: 'Kurye Bekleyen Riskli Siparişler',
  DELAYED_ON_COURIER: 'Kuryede Gecikme Riskli Siparişler',
  DELAYED_DELIVERY_AND_WAITING_FOR_DELIVERY: 'Teslimatı Geciken Siparişler',
  DELAYED_DELIVERY_FROM_STORE:'Mağazadan Teslimatı Geciken Siparişler',
  DELAYED_APPROVAL: 'Onay Geciken Siparişler',
  storeOperations: "Mağaza Operasyonları",
  courierOperations: "Dağıtıcı Operasyonları",
  amountFromExtra: "Fazla Toplamadan Kaynaklanan Tutar (TL)",
  reportType: 'Rapor Tipi',
  actionType: 'Aksiyon Tipi',
  ordersPendingActionMessage: 'Lütfen listelemek istediğiniz siparişler için Mağaza ve Filtre seçimi yapınız !!!',
  maxSelectedDateRangeOneDayOrSelectCity: "Mağaza seçiniz veya tarih filtresini 2 güne indiriniz!",
  sendEmail: 'E-Mail Gönder',
  showDescription: 'Açıklamayı Göster',
  reportsGenerateMessage: '{{reportTemplate}} Raporu Mail Adresinize Gönderilmiştir',
  STAFF: 'KADROLU',
  TRADESMAN: 'ESNAF',
  massNotification: "Toplu Bilgilendirme",
  addMassNotification: "Toplu Bilgilendirme Oluşturma",
  notificationMethod: "Bilgilendirme Yöntemi",
  targetUsers: "Hedef Kullanıcılar",
  targetDate: "Hedef Zaman",
  notificationText: "Bilgilendirme Metni",
  notificationHeader: "Bilgilendirme Başlığı",
  addedNotification: 'Toplu Bilgilendirme Oluşturulmuştur',
  notificationDate: 'Bilgilendirme Tarihi Seçiniz',
  INSTANT: 'Hemen',
  PLANNED: 'Planlı',
  ANNOUNCEMENT: "DUYURU",
  PUSH: "BİLDİRİM",
  resendNotification: 'Bilgilendirmeyi Tekrar Gönder',
  targetUser: "Hedef Kullanıcı",
  scheduledDate: 'Planlanan Zaman',
  SENT: 'GÖNDERİLDİ',
  COULD_NOT_SEND: 'GÖNDERİLEMEDİ',
  maxLength250Character: 'Max 250 karakter olmalıdır',
  sendSmsOptionTitle: 'Yeni Siparişte SMS Gönder',
  transportationMethods: 'Sevkiyat Yöntemlerini Taşıma',
  shipmentMethodToMove: 'Sevkiyat Yöntemleri Taşınsın',
  shippingMethodsDefine: 'Sevkiyat Yöntemlerini Tanımla',
  selectTheShipmentMethod: 'Sevkiyat Yöntemleri Seçiniz',
  EXCEL_UPLOAD: 'EXCEL YÜKLEME',
  bonus: 'Prim',
  bonusType: 'Prim Tipi',
  CUSTOMER_SURVEY: 'Müşteri Anketi',
  PER_ORDER: 'Sipariş Bazında',
  PER_RATING: 'Değerlendirme Bazında',
  bonusAndPenalty: 'Prim/Kesinti',
  initial: 'Yeni',
  reviewing: 'İnceleniyor',
  applicable: 'Çalışmaya Uygun',
  notApplicable: 'Çalışmaya Uygun Değil',
  not_applicable: 'Çalışmaya Uygun Değil',
  closed: 'Kapatıldı',
  statusAndDescription: 'Durum ve Açıklama',
  updatedCourierApplication: 'Dağıtıcı Başvuru Durumu Güncellendi',
  method: 'Yöntem',
  isDuplicateCombination: 'Aynı Prim/Kesinti zaten mevcut. Başka bir Prim/Kesinti seçiniz.',
  createdBeforeCombination: 'Tüm mevcut seçeneklerle Prim/Kesinti oluşturulmuştur.',
  pleaseFillAllFields: 'Lütfen tüm alanları doldurunuz.',
  penalty: 'Kesinti',
  bonusAndPenaltyType: 'Prim/Kesinti Tipi',
  minPoint: 'Min Puan',
  maxPoint: 'Max Puan',
  minMustBeGreaterThanLastMin: "Min Bir Önceki Max'tan Büyük Olmalıdır",
  maxMustBeGreaterThanMin: "Max Değer Min Değerden Büyük Olmalıdır",
  customerType: 'Müşteri Tipi',
  priority: 'Zone Önceliği',
  isDuplicateCombinationRuleSet: 'Aynı Kural Seti zaten mevcut. Başka bir Kural Seti seçiniz.',
  createdBeforeCombinationRuleSet: 'Tüm mevcut seçeneklerle Kural Seti oluşturulmuştur.',
  ruleType: 'Kural Tipi',
  effect: 'Etkisi',
  coefficient: 'Katsayı',
  coefficientMustBeGreaterThanPrevious: 'Katsayı bir öncekinden büyük olmalıdır.',
  addStoreProgressPayment: 'Mağaza Hakediş Ekle',
  addCourierProgressPayment: 'Dağıtıcı Hakediş Ekle',
  addProgressPayment: 'Hakediş Ekle',
  specialDayProgressPayment: 'Özel Gün Hakedişi',
  vestingPercentage: 'İlave Hakediş Değeri',
  addNewSpecialDay: 'Yeni Özel Gün Hakedişi Ekle',
  rulePositive: 'Ücret Ekle',
  ruleNegative: 'Ücret Çıkar',
  ORDER_AVERAGE: 'Sipariş Ortalaması',
  coefficientMultiplier: 'Katsayı Çarpanı',
  conditions: 'Koşullar',
  conditionType: 'Koşul Tipi',
  STORE: 'MAĞAZA',
  templateType: 'Şablon Tipi',
  editStoreProgressPayment: 'Mağaza Hakediş Düzenle',
  addNewBonusPenalty: 'Yeni Prim/Kesinti Ekle',
  defineRuleSet: 'Kural Seti Tanımla',
  storeProgressPaymentTracking: 'Mağaza Hakediş Takibi',
  courierProgressPaymentTracking: 'Dağıtıcı Hakediş Takibi',
  advancePaymentInvoiceStatus: 'Avans Fatura Durumu',
  invoiceInformation: 'Avans Fatura Tutarı',
  NOT_PROCESSED: 'İşlenmedi',
  SUCCESS: 'Başarılı',
  cancelledOrderSize: 'İptal Sipariş Sayısı',
  percentage: 'Oran',
  storeProgressPaymentCourierDetail: 'Mağaza Hakediş Detayı',
  courierCoordinateTimeOfDelivery: 'Kuryenin Teslimat Anındaki Koordinatı',
  legalTitle: 'Tüzel Ünvan',
  vknErrMessage: 'VKN 10-12 karakter arasında olmalıdır!',
  regularOrder: 'Normal Sipariş',
  regularOrderPrice: 'Normal Sipariş Fiyatı',
  changeOrder: 'Değişim Siparişi',
  returnPickup: 'İade Siparişi',
  changeOrderPrice: 'Değişim Siparişi Fiyatı',
  returnPickupOrderPrice: 'İade Siparişi Fiyatı',
  additionalExists: 'Var',
  additionalNotExists: 'Yok',
  WAITING_APPROVAL: 'Onay Bekliyor',
  WAITING_FINANCE_APPROVAL: 'Muhasebe Onayı Bekliyor',
  DECLINED: 'Reddedildi',
  LEFT: 'Ayrıldı',
};
